import { ecmrTranslations } from './ecmr-translations';
import { waybillTranslations } from './waybill-translations';
import { termsTranslations } from './terms-translations';
import { developersTranslations } from './developers-translations';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { I18N_CONFIG } from './config';
import { signatureTranslations } from './signature-translations';
import { evidenceTranslations } from './evidence-translations';

// Traducciones
const resources = {
  es: {
    common: {
      'solicitar-demo': 'Solicitar Demo',
      'contacto': 'Contacto',
      'caracteristicas': 'Cómo funciona',
      'interoperabilidad': 'Interoperabilidad',
      'confianza': 'Confianza',
      'articulos': 'Artículos',
      'plataforma': 'Plataforma'
    },
    header: {
      'nav-plataforma': 'Plataforma',
      'nav-plataforma-caracteristicas': 'Cómo funciona',
      'nav-plataforma-caracteristicas-desc': 'El ciclo de vida del documento',
      'nav-plataforma-interoperabilidad': 'Integraciones',
      'nav-plataforma-interoperabilidad-desc': 'Integración con sistemas',
      'nav-plataforma-confianza': 'Confianza y Seguridad',
      'nav-plataforma-confianza-desc': 'Cumplimiento y protección',
      'nav-documentos': 'Documentos',
      'nav-documentos-control': 'DeCA (Documento de Control)',
      'nav-documentos-control-desc': '🇪🇸 Obligatorio en España',
      'nav-documentos-carta': 'Carta de Porte Digital',
      'nav-documentos-carta-desc': '🇪🇸 Contractual nacional',
      'nav-documentos-ecmr': 'eCMR',
      'nav-documentos-ecmr-desc': '42 Partes del Protocolo eCMR',
      'nav-documentos-adr': 'Documento de Transporte ADR',
      'nav-documentos-adr-desc': 'Mercancías peligrosas',
      'nav-confianza-cumplimiento': 'Cumplimiento Normativo',
      'nav-confianza-cumplimiento-desc': 'Regulaciones y estándares',
      'nav-confianza-seguridad': 'Seguridad',
      'nav-confianza-seguridad-desc': 'Protección de datos',
      'nav-confianza-firma': 'Firma Electrónica',
      'nav-confianza-firma-desc': 'Firma avanzada eIDAS',
      'nav-confianza-conservacion': 'Conservación de Evidencias',
      'nav-confianza-conservacion-desc': 'Custodia segura',
      'nav-empresa': 'Empresa',
      'nav-empresa-quienes': 'Quiénes somos',
      'nav-empresa-quienes-desc': 'Nuestra historia y equipo',
      'nav-empresa-articulos': 'Artículos',
      'nav-empresa-articulos-desc': 'Guías y recursos',
      'nav-contacto': 'Contacto',
      'nav-contacto-desc': 'Ponte en contacto con nosotros',
      'nav-caracteristicas': 'Cómo funciona',
      'nav-interoperabilidad': 'Integraciones',
      'nav-confianza': 'Confianza',
      'nav-precios': 'Precios',
      'nav-articulos': 'Artículos',
      'nav-desarrolladores': 'Desarrolladores',
      'nav-desarrolladores-desc': 'API, documentación y herramientas',
      'solicitar-demo': 'Solicitar Demo',
      'prueba-gratis': 'Solicitar Prueba',
      'acceder': 'Acceder'
    },
    footer: {
      'solucion': 'Solución',
      'como-funciona': 'Cómo funciona',
      'interoperabilidad': 'Interoperabilidad',
      'recursos': 'Recursos',
      'documentos': 'Documentos',
      'empresa': 'Empresa',
      'quienes-somos': 'Quiénes somos',
      'demo': 'Demo',
      'periodo-prueba': 'Periodo de prueba',
      'contacto': 'Contacto',
      'product-sheet': 'Hoja de producto (PDF)',
      'legal': 'Legal',
      'terminos': 'Términos y condiciones',
      'faq': 'FAQ',
      'articulos-guias': 'Artículos',
      'confianza': 'Confianza',
      'cumplimiento': 'Cumplimiento normativo',
      'seguridad': 'Seguridad',
      'firma': 'Firma y evidencias',
      'conservacion': 'Conservación de evidencias',
      'doc-control': 'DeCA (documento de control)',
      'carta-porte': 'Carta de porte',
      'waybill': 'Carta de Porte',
      'politica-privacidad': 'Política de privacidad',
      'politica-cookies': 'Política de cookies',
      'aviso-legal': 'Aviso legal',
      'dpa': 'DPA',
      'cta-text': 'Prepárese para la documentación electrónica. Solicite una demo hoy mismo.',
      'cta-button': 'Solicitar demo',
      'copyright': 'Todos los derechos reservados.',
      'made-in': 'Hecho en España',
      'desarrolladores': 'Desarrolladores',
      'nav-caracteristicas': 'Cómo funciona',
      'nav-interoperabilidad': 'Integraciones',
      'nav-confianza': 'Confianza'
    },
    demo: {
      'title': 'Solicitar Demo de BlueCMR',
      'subtitle': 'Descubra cómo BlueCMR puede digitalizar sus documentos de transporte con validez jurídica completa',
      'form-title': 'Solicite su demo gratuita',
      'success-message': '¡Gracias! Nos pondremos en contacto con usted para programar su demo personalizada.',
      'name': 'Nombre',
      'email': 'Email',
      'company': 'Empresa',
      'phone': 'Teléfono',
      'company-type': 'Tipo de empresa',
      'select': 'Seleccione',
      'submit': 'Solicitar demo gratuita'
    },
    landing: {
      'hero-title': 'Documentos de transporte digitales y profesionales',
      'hero-subtitle': 'Plataforma segura y con validez jurídica para transportistas y cargadores',
      'hero-cta': 'Solicitar demo',
      'hero-cta-secondary': 'Ver guías',
      'trusted-by': 'Digitalización del transporte',
      'mandatory-banner': 'DeCA (documento de control) obligatorio desde el 05 de octubre de 2026',
      'mandatory-banner-cta': 'Más información',
      'benefits-title': 'Beneficios inmediatos',
      'benefit-compliance': 'Cumplimiento normativo',
      'benefit-compliance-desc': 'Documentos válidos en inspección en tránsito con total garantía legal',
      'benefit-efficiency': 'Ahorro administrativo',
      'benefit-efficiency-desc': 'Reduzca horas de administración y agilice el cobro de facturas',
      'benefit-security': 'Más seguros',
      'benefit-security-desc': 'Firmas digitales avanzadas y documentos siempre disponibles',
      'benefit-professional': 'Profesionalidad',
      'benefit-professional-desc': 'Gestión documental moderna y profesional con clientes',
      'cta-final-title': 'Empiece hoy la transición documental',
      'cta-final-subtitle': 'Únase a las empresas que ya están preparadas para el futuro digital del transporte',
      'cta-final-button': 'Solicitar demo'
    },
    contact: {
      'title': 'Contacto',
      'subtitle': '¿Tiene preguntas sobre BlueCMR? Estamos aquí para ayudarle.',
      'info-title': 'Información de contacto',
      'email': 'Email',
      'location': 'Ubicación',
      'location-desc': 'Servicio en toda la Unión Europea',
      'schedule': 'Horario de atención',
      'schedule-hours': 'Lunes a viernes: 08:30 - 15:00',
      'schedule-timezone': 'Zona horaria: CET (Madrid)',
      'form-title': 'Envíenos un mensaje',
      'form-name': 'Nombre',
      'form-email': 'Email',
      'form-company': 'Empresa',
      'form-subject': 'Asunto',
      'form-subject-placeholder': 'Seleccione un asunto',
      'form-subject-demo': 'Solicitar demo',
      'form-subject-support': 'Soporte técnico',
      'form-subject-integration': 'Integración con sistemas',
      'form-subject-other': 'Otro',
      'form-message': 'Mensaje',
      'form-message-placeholder': 'Cuéntenos cómo podemos ayudarle...',
      'form-privacy': 'Acepto la política de privacidad y el tratamiento de mis datos personales.',
      'form-submit': 'Enviar mensaje',
      'form-submitting': 'Enviando...',
      'form-success': '¡Gracias! Hemos recibido su mensaje correctamente.',
      'form-error': 'Error al enviar el formulario. Por favor, inténtalo de nuevo.',
      'form-wait': 'Por favor, espera unos segundos antes de enviar otro mensaje.',
      'form-review': 'Por favor, tómate un momento para revisar el formulario.',
      'form-attempts': 'Demasiados intentos. Por favor, recarga la página.'
    },
    plataforma: {
      'title': 'La plataforma DeCA de BlueCMR: cómo funciona',
      'subtitle': 'El ciclo de vida completo de sus documentos de transporte, desde la creación hasta la conservación',
      'features-title': 'Funcionalidades principales',
      'feature-documents': 'Documentos soportados',
      'feature-documents-desc': 'DeCA, Carta de Porte, eCMR Internacional',
      'feature-signature': 'Firma electrónica avanzada',
      'feature-signature-desc': 'Conforme a eIDAS con biometría manuscrita',
      'feature-custody': 'Custodia segura',
      'feature-custody-desc': 'Cifrado y almacenamiento hasta 10 años',
      'feature-api': 'API abierta',
      'feature-api-desc': 'Integración con TMS, ERP y sistemas existentes',
      'benefits-title': 'Beneficios para su empresa',
      'benefit-compliance': 'Cumplimiento normativo total',
      'benefit-efficiency': 'Reducción del 80% en tiempo administrativo',
      'benefit-security': 'Seguridad y trazabilidad completa',
      'cta-title': 'Comience hoy mismo',
      'cta-subtitle': 'Solicite una demostración personalizada',
      'cta-button': 'Solicitar demo'
    },
    interoperabilidad: {
      'title': 'Integra BlueCMR con tu ecosistema tecnológico',
      'subtitle': 'API, webhooks, enlaces embebidos e importación/exportación para conectar con TMS, ERP y flotas',
      'tech-team-cta': 'Habla con nuestro equipo técnico',
      'flexible-integration': 'Integración flexible según tus necesidades',
      'connect-ecosystem': 'Conecta BlueCMR con tu ecosistema tecnológico existente',
      'interoperability-options': 'Opciones de interoperabilidad',
      'examples-title': 'Ejemplos de integración',
      'cta-final': '¿Listo para integrar BlueCMR?',
      'tech-demo': 'Solicita una demo técnica y descubre cómo conectar con tus sistemas',
      'developer-portal': 'Portal de desarrolladores',
      'tech-info-title': 'Solicita información técnica',
      'tech-info-desc': 'Descubre cómo integrar BlueCMR',
      'corporate-email': 'Email corporativo',
      'system-optional': 'Sistema a integrar (opcional)',
      'own-system': 'Sistema propio',
      'fleet-system': 'Sistema de flota',
      'other': 'Otro',
      'request-info': 'Solicitar Información',
      'api-rest': 'API REST',
      'api-rest-desc': 'Integración directa desde TMS, ERP o sistemas propios',
      'create-docs': 'Crear documentos',
      'send-sign': 'Enviar para firma',
      'check-status': 'Consultar estados',
      'download-signed': 'Descargar firmados',
      'api-note': 'Pensado para integraciones profundas y automatizadas',
      'webhooks': 'Webhooks y Eventos',
      'webhooks-desc': 'Reacciona automáticamente a cambios en documentos',
      'doc-created': 'Documento creado',
      'doc-signed': 'Documento firmado',
      'incidents': 'Incidencias',
      'sync-status': 'Sincronización de estados',
      'webhooks-note': 'Ideal para mantener sistemas sincronizados sin polling',
      'embedded-links': 'Enlaces Embebidos',
      'embedded-desc': 'Flujos de firma y acceso integrados en apps móviles o portales',
      'mobile-apps': 'Apps móviles',
      'driver-pda': 'PDAs conductor',
      'client-portals': 'Portales cliente',
      'focused-integration': 'Integración focalizada en puntos del flujo',
      'embedded-note': 'Perfecto para integrar la firma y el acceso a documentos dentro de sistemas existentes',
      'import-export': 'Importación/Exportación',
      'import-desc': 'Cargas masivas y sincronización con sistemas heredados',
      'bulk-loads': 'Cargas masivas',
      'progressive': 'Integración progresiva',
      'legacy-systems': 'Sistemas heredados',
      'adapted-pace': 'Ritmo adaptado',
      'import-note': 'Adecuado para integraciones progresivas o entornos con sistemas heredados',
      'tms-integration': 'Integración con TMS',
      'auto-generation': 'Generación automática al crear envío',
      'status-sync': 'Sincronización de estados',
      'signed-recovery': 'Recuperación de firmados',
      'tms-result': 'El documento se genera automáticamente y se devuelve firmado al sistema',
      'erp-integration': 'Integración con ERP',
      'auto-archive': 'Archivo automático',
      'order-association': 'Asociación con pedidos/facturas',
      'compliant-storage': 'Conservación conforme',
      'erp-result': 'El documento queda archivado y vinculado al ciclo administrativo',
      'fleet-integration': 'Integración con Flotas',
      'mobile-sign': 'Firma desde móviles/PDAs',
      'qr-sms-links': 'Enlaces por QR/SMS',
      'immediate-access': 'Acceso inmediato en ruta',
      'fleet-result': 'El conductor accede y firma directamente en ruta',
      'eliminate-manual': 'Eliminar introducción manual de datos',
      'automate-generation': 'Automatizar generación de documentos',
      'sync-states': 'Sincronizar estados y eventos',
      'integrate-signature': 'Integrar firma electrónica en flujos',
      'ensure-compliance': 'Garantizar cumplimiento normativo',
      'complement-systems': 'Complementar TMS, ERP y flotas',
      'secure-integrations': 'Integraciones seguras, con control total de accesos y permisos',
      'security-by-design': 'Todas las integraciones operan bajo principios de seguridad por diseño',
      'controlled-auth': 'Autenticación controlada',
      'limited-permissions': 'Permisos limitados por cuenta',
      'encrypted-comms': 'Cifrado de comunicaciones',
      'access-control': 'Control de accesos y revocación',
      'open-platform': 'Plataforma abierta, sin bloqueo tecnológico',
      'open-platform-desc': 'Los documentos y evidencias pueden exportarse y verificarse de forma independiente',
      'docs-exportable': 'Los documentos pueden exportarse',
      'evidence-verifiable': 'Las evidencias son verificables',
      'no-modify-systems': 'No obliga a modificar sistemas existentes'
    },
    confianza: {
      'title': 'Confianza y Seguridad',
      'subtitle': 'La seguridad y validez legal de sus documentos es nuestra prioridad',
      'legal-title': 'Validez jurídica completa',
      'legal-desc': 'Documentos válidos ante inspecciones y con total garantía legal',
      'eidas-title': 'Cumplimiento eIDAS',
      'eidas-desc': 'Firma electrónica avanzada conforme al Reglamento Europeo',
      'timestamp-title': 'Sellado de tiempo',
      'timestamp-desc': 'Evidencia temporal irrefutable de la creación del documento',
      'custody-title': 'Custodia segura',
      'custody-desc': 'Almacenamiento cifrado y accesible hasta 10 años',
      'audit-title': 'Trazabilidad completa',
      'audit-desc': 'Registro detallado de todas las acciones y modificaciones',
      'certificates-title': 'Certificaciones',
      'certificate-iso': 'ISO 27001 - Seguridad de la información',
      'certificate-gdpr': 'RGPD - Protección de datos',
      'certificate-eidas': 'eIDAS - Firma electrónica'
    }
  },
  en: {
    common: {
      'solicitar-demo': 'Request demo',
      'contacto': 'Contact',
      'caracteristicas': 'How it works',
      'interoperabilidad': 'Interoperability',
      'confianza': 'Trust',
      'articulos': 'Articles',
      'plataforma': 'Platform'
    },
    header: {
      'nav-plataforma': 'Platform',
      'nav-plataforma-caracteristicas': 'How it works',
      'nav-plataforma-caracteristicas-desc': 'The document lifecycle',
      'nav-plataforma-interoperabilidad': 'Integrations',
      'nav-plataforma-interoperabilidad-desc': 'System integration',
      'nav-plataforma-confianza': 'Trust and Security',
      'nav-plataforma-confianza-desc': 'Compliance and protection',
      'nav-documentos': 'Documents',
      'nav-documentos-control': 'Control Document',
      'nav-documentos-control-desc': '🇪🇸 Mandatory in Spain',
      'nav-documentos-carta': 'Digital Waybill',
      'nav-documentos-carta-desc': '🇪🇸 National contractual',
      'nav-documentos-ecmr': 'eCMR',
      'nav-documentos-ecmr-desc': '🇪🇺 Nearly 40 member countries',
      'nav-documentos-adr': 'ADR Transport Document',
      'nav-documentos-adr-desc': 'Dangerous goods',
      'nav-confianza-cumplimiento': 'Regulatory Compliance',
      'nav-confianza-cumplimiento-desc': 'Regulations and standards',
      'nav-confianza-seguridad': 'Security',
      'nav-confianza-seguridad-desc': 'Data protection',
      'nav-confianza-firma': 'Electronic Signature',
      'nav-confianza-firma-desc': 'eIDAS advanced signature',
      'nav-confianza-conservacion': 'Evidence Preservation',
      'nav-confianza-conservacion-desc': 'Secure custody',
      'nav-empresa': 'Company',
      'nav-empresa-quienes': 'About us',
      'nav-empresa-quienes-desc': 'Our story and team',
      'nav-empresa-articulos': 'Articles',
      'nav-empresa-articulos-desc': 'Guides and resources',
      'nav-contacto': 'Contact',
      'nav-caracteristicas': 'How it works',
      'nav-interoperabilidad': 'Integrations',
      'nav-confianza': 'Trust',
      'nav-articulos': 'Articles',
      'nav-desarrolladores': 'Developers',
      'nav-desarrolladores-desc': 'API, docs and tools',
      'solicitar-demo': 'Request demo',
      'prueba-gratis': 'Request trial',
      'acceder': 'Log in',
      'nav-contacto-desc': 'Get in touch with us'
    },
    footer: {
      'solucion': 'Solution',
      'como-funciona': 'How it works',
      'interoperabilidad': 'Interoperability',
      'recursos': 'Resources',
      'documentos': 'Documents',
      'empresa': 'Company',
      'quienes-somos': 'About us',
      'demo': 'Demo',
      'periodo-prueba': 'Trial period',
      'contacto': 'Contact',
      'product-sheet': 'Product sheet (PDF)',
      'legal': 'Legal',
      'terminos': 'Terms and Conditions',
      'faq': 'FAQ',
      'articulos-guias': 'Articles',
      'confianza': 'Trust',
      'cumplimiento': 'Regulatory Compliance',
      'seguridad': 'Security',
      'firma': 'Signature and Evidence',
      'conservacion': 'Evidence Preservation',
      'waybill': 'Digital Waybill',
      'politica-privacidad': 'Privacy policy',
      'politica-cookies': 'Cookie policy',
      'aviso-legal': 'Legal Notice',
      'dpa': 'DPA',
      'cta-text': 'Get ready for electronic documentation. Request a demo today.',
      'cta-button': 'Request demo',
      'copyright': 'All rights reserved.',
      'made-in': 'Made in Spain',
      'desarrolladores': 'Developers',
      'nav-caracteristicas': 'How it works',
      'nav-interoperabilidad': 'Integrations',
      'nav-confianza': 'Trust'
    },
    demo: {
      'title': 'Request BlueCMR Demo',
      'subtitle': 'Discover how BlueCMR can digitize your transport documents with complete legal validity',
      'form-title': 'Request your free demo',
      'success-message': 'Thank you! We will contact you to schedule your personalized demo.',
      'name': 'Name',
      'email': 'Email',
      'company': 'Company',
      'phone': 'Phone',
      'company-type': 'Company type',
      'select': 'Select',
      'submit': 'Request free demo'
    },
    landing: {
      'hero-title': 'Digital and professional transport documents',
      'hero-subtitle': 'Secure platform with legal validity for carriers and shippers',
      'hero-cta': 'Request demo',
      'hero-cta-secondary': 'View guides',
      'trusted-by': 'Transport digitization',
      'benefits-title': 'Immediate benefits',
      'benefit-compliance': 'Regulatory compliance',
      'benefit-compliance-desc': 'Documents valid for inspection in transit with complete legal guarantee',
      'benefit-efficiency': 'Administrative savings',
      'benefit-efficiency-desc': 'Reduce administration hours and speed up invoice collection',
      'benefit-security': 'More secure',
      'benefit-security-desc': 'Advanced digital signatures and documents always available',
      'benefit-professional': 'Professionalism',
      'benefit-professional-desc': 'Modern and professional document management with clients',
      'cta-final-title': 'Start the document transition today',
      'cta-final-subtitle': 'Join companies that are already prepared for the digital future of transport',
      'cta-final-button': 'Request demo'
    },
    contact: {
      'title': 'Contact',
      'subtitle': 'Do you have questions about BlueCMR? We are here to help you.',
      'info-title': 'Contact information',
      'email': 'Email',
      'location': 'Location',
      'location-desc': 'Service throughout the European Union',
      'schedule': 'Business hours',
      'schedule-hours': 'Monday to Friday: 08:30 - 15:00',
      'schedule-timezone': 'Time zone: CET (Madrid)',
      'form-title': 'Send us a message',
      'form-name': 'Name',
      'form-email': 'Email',
      'form-company': 'Company',
      'form-subject': 'Subject',
      'form-subject-placeholder': 'Select a subject',
      'form-subject-demo': 'Request demo',
      'form-subject-support': 'Technical support',
      'form-subject-integration': 'System integration',
      'form-subject-other': 'Other',
      'form-message': 'Message',
      'form-message-placeholder': 'Tell us how we can help you...',
      'form-privacy': 'I accept the privacy policy and the processing of my personal data.',
      'form-submit': 'Send message',
      'form-submitting': 'Sending...',
      'form-success': 'Thank you! We have received your message correctly.',
      'form-error': 'Error sending the form. Please try again.',
      'form-wait': 'Please wait a few seconds before sending another message.',
      'form-review': 'Please take a moment to review the form.',
      'form-attempts': 'Too many attempts. Please reload the page.'
    },
    plataforma: {
      'title': 'How BlueCMR works',
      'subtitle': 'The complete lifecycle of your transport documents, from creation to preservation',
      'features-title': 'Main functionalities',
      'feature-documents': 'Supported documents',
      'feature-documents-desc': 'Digital DCA, Waybill, International eCMR',
      'feature-signature': 'Advanced electronic signature',
      'feature-signature-desc': 'eIDAS compliant with handwritten biometrics',
      'feature-custody': 'Secure custody',
      'feature-custody-desc': 'Encrypted storage for up to 10 years',
      'feature-api': 'Open API',
      'feature-api-desc': 'Integration with TMS, ERP and existing systems',
      'benefits-title': 'Benefits for your company',
      'benefit-compliance': 'Total regulatory compliance',
      'benefit-efficiency': '80% reduction in administrative time',
      'benefit-security': 'Complete security and traceability',
      'cta-title': 'Start today',
      'cta-subtitle': 'Request a personalized demonstration',
      'cta-button': 'Request demo'
    },
    interoperabilidad: {
      'title': 'Integrate BlueCMR with your technology ecosystem',
      'subtitle': 'API, webhooks, embedded links and import/export to connect with TMS, ERP and fleets',
      'tech-team-cta': 'Talk to our technical team',
      'flexible-integration': 'Flexible integration according to your needs',
      'connect-ecosystem': 'Connect BlueCMR with your existing technology ecosystem',
      'interoperability-options': 'Interoperability options',
      'examples-title': 'Integration examples',
      'cta-final': 'Ready to integrate BlueCMR?',
      'tech-demo': 'Request a technical demo and discover how to connect with your systems',
      'developer-portal': 'Developer portal',
      'tech-info-title': 'Request technical information',
      'tech-info-desc': 'Discover how to integrate BlueCMR',
      'corporate-email': 'Corporate email',
      'system-optional': 'System to integrate (optional)',
      'own-system': 'Own system',
      'fleet-system': 'Fleet system',
      'other': 'Other',
      'request-info': 'Request Information',
      'api-rest': 'REST API',
      'api-rest-desc': 'Direct integration from TMS, ERP or own systems',
      'create-docs': 'Create documents',
      'send-sign': 'Send for signature',
      'check-status': 'Check statuses',
      'download-signed': 'Download signed',
      'api-note': 'Designed for deep and automated integrations',
      'webhooks': 'Webhooks and Events',
      'webhooks-desc': 'React automatically to document changes',
      'doc-created': 'Document created',
      'doc-signed': 'Document signed',
      'incidents': 'Incidents',
      'sync-status': 'Status synchronization',
      'webhooks-note': 'Ideal for keeping systems synchronized without polling',
      'embedded-links': 'Embedded Links',
      'embedded-desc': 'Signature and access flows integrated in mobile apps or portals',
      'mobile-apps': 'Mobile apps',
      'driver-pda': 'Driver PDAs',
      'client-portals': 'Client portals',
      'focused-integration': 'Focused integration at flow points',
      'embedded-note': 'Perfect for integrating signature and document access within existing systems',
      'import-export': 'Import/Export',
      'import-desc': 'Bulk loads and synchronization with legacy systems',
      'bulk-loads': 'Bulk loads',
      'progressive': 'Progressive integration',
      'legacy-systems': 'Legacy systems',
      'adapted-pace': 'Adapted pace',
      'import-note': 'Suitable for progressive integrations or environments with legacy systems',
      'tms-integration': 'TMS Integration',
      'auto-generation': 'Automatic generation when creating shipment',
      'status-sync': 'Status synchronization',
      'signed-recovery': 'Signed recovery',
      'tms-result': 'The document is automatically generated and returned signed to the system',
      'erp-integration': 'ERP Integration',
      'auto-archive': 'Automatic archiving',
      'order-association': 'Association with orders/invoices',
      'compliant-storage': 'Compliant storage',
      'erp-result': 'The document is archived and linked to the administrative cycle',
      'fleet-integration': 'Fleet Integration',
      'mobile-sign': 'Sign from mobile/PDAs',
      'qr-sms-links': 'Links via QR/SMS',
      'immediate-access': 'Immediate access on route',
      'fleet-result': 'The driver accesses and signs directly on route',
      'eliminate-manual': 'Eliminate manual data entry',
      'automate-generation': 'Automate document generation',
      'sync-states': 'Synchronize states and events',
      'integrate-signature': 'Integrate electronic signature in flows',
      'ensure-compliance': 'Ensure regulatory compliance',
      'complement-systems': 'Complement TMS, ERP and fleets',
      'secure-integrations': 'Secure integrations, with full access and permission control',
      'security-by-design': 'All integrations operate under security by design principles',
      'controlled-auth': 'Controlled authentication',
      'limited-permissions': 'Limited permissions per account',
      'encrypted-comms': 'Encrypted communications',
      'access-control': 'Access control and revocation',
      'open-platform': 'Open platform, no technology lock-in',
      'open-platform-desc': 'Documents and evidence can be exported and verified independently',
      'docs-exportable': 'Documents can be exported',
      'evidence-verifiable': 'Evidence is verifiable',
      'no-modify-systems': 'Does not require modifying existing systems'
    },
    confianza: {
      'title': 'Trust and Security',
      'subtitle': 'The security and legal validity of your documents is our priority',
      'legal-title': 'Complete legal validity',
      'legal-desc': 'Documents valid for inspections with complete legal guarantee',
      'eidas-title': 'eIDAS Compliance',
      'eidas-desc': 'Advanced electronic signature compliant with European Regulation',
      'timestamp-title': 'Timestamping',
      'timestamp-desc': 'Irrefutable temporal evidence of document creation',
      'custody-title': 'Secure custody',
      'custody-desc': 'Encrypted and accessible storage for up to 10 years',
      'audit-title': 'Complete traceability',
      'audit-desc': 'Detailed record of all actions and modifications',
      'certificates-title': 'Certifications',
      'certificate-iso': 'ISO 27001 - Information security',
      'certificate-gdpr': 'GDPR - Data protection',
      'certificate-eidas': 'eIDAS - Electronic signature'
    },
    blog: {
      'title': 'BlueCMR Blog',
      'subtitle': 'News, guides and resources about digital control documents',
      'categories': {
        'all': 'All',
        'administrative': 'Administrative Control',
        'international': 'International CMR',
        'delivery': 'Delivery Note',
        'ecmr': 'eCMR',
        'regulation': 'Regulation',
        'management': 'Management',
        'integrations': 'Integrations',
        'technology': 'Technology',
        'success': 'Success Stories',
        'tutorials': 'Tutorials'
      },
      'featured': 'Featured',
      'readArticle': 'Read Article',
      'readMore': 'Read more',
      'newsletter': {
        'title': 'Don\'t want to miss anything?',
        'subtitle': 'Subscribe to our newsletter and receive the latest industry news',
        'placeholder': 'your@email.com',
        'button': 'Subscribe'
      }
    },
    faq: {
      'title': 'Frequently asked questions',
      'subtitle': 'We resolve the most common doubts about document digitization in transport.',
      'questions': [
        {
          'question': 'Is the Digital Control Document mandatory?',
          'answer': 'Not yet. Digital DCA is legal in Spain, but its mandatory nature is expected within the 2026 regulatory framework.'
        },
        {
          'question': 'Is eCMR valid in Spain?',
          'answer': 'Yes. Spain is a signatory to the Additional Protocol to the CMR Convention that recognizes the validity of eCMR.'
        },
        {
          'question': 'What type of signature does BlueCMR use?',
          'answer': 'BlueCMR uses advanced electronic signature: handwritten biometric, compliant with eIDAS Regulation.'
        },
        {
          'question': 'Where are documents stored?',
          'answer': 'In encrypted cloud custody, with guaranteed availability for up to 10 years and access to evidence in case of inspection.'
        },
        {
          'question': 'Can I integrate BlueCMR with my current systems?',
          'answer': 'Yes. BlueCMR offers REST API, webhooks and embedded options to integrate with TMS, ERP or driver PDAs.'
        },
        {
          'question': 'What happens if a driver has no connection?',
          'answer': 'Documents can be viewed offline.'
        },
        {
          'question': 'What differentiates BlueCMR from other solutions?',
          'answer': 'Its ease of use, self-managed approach and competitive costs, along with a solid legal and technical framework.'
        }
      ],
      'moreQuestions': {
        'title': 'Do you have more questions?',
        'description': 'If your case does not appear in the frequently asked questions, you can contact us directly. Our team will help you evaluate how BlueCMR adapts to your processes.',
        'button': 'Talk to us'
      }
    },
    guias: {
      'title': 'Guides and Articles',
      'subtitle': 'Everything you need to know about digital transport documentation',
      'description': 'Practical guides, legal frameworks and best practices for transport digitization',
      'exploreByTopic': {
        'title': 'Explore by topic',
        'subtitle': 'Find the information you need organized by areas of interest'
      },
      'categories': {
        'documents': {
          'title': 'Documents',
          'articlesCount': 'specialized articles'
        },
        'compliance': {
          'title': 'Regulation and compliance',
          'articlesCount': 'specialized articles'
        },
        'technology': {
          'title': 'Operation and technology',
          'articlesCount': 'specialized articles'
        }
      },
      'featured': {
        'title': 'Featured articles',
        'subtitle': 'The most useful articles to start your digitization'
      },
      'readArticle': 'Read article',
      'viewAll': 'View all articles',
      'readComplete': 'Read complete guide',
      'cta': {
        'title': 'Ready to digitize?',
        'subtitle': 'Put into practice everything you have learned with a personalized BlueCMR demo',
        'button': 'Request free demo'
      }
    },
    dcaDigital: {
      'title': 'Digital Administrative Transport Control Document Mandatory',
      'subtitle': 'Complete guide: current legality, technical requirements and benefits',
      'cta': 'Request Digital Control Document demo'
    },
    ecmrDigital: {
      'title': 'eCMR: the electronic waybill in digital international transport',
      'subtitle': 'Complete guide on the electronic international transport document',
      'cta': 'Request eCMR demo'
    },
    efti: {
      'title': 'What is eFTI and how will it impact transport documentation?',
      'subtitle': 'Complete guide on eFTI regulation: timeline, benefits and impact on digital transport documents.',
      'cta': 'Request eFTI demo'
    }
  },
  fr: {
    common: {
      'solicitar-demo': 'Demander une démo',
      'contacto': 'Contact',
      'caracteristicas': 'Fonctionnalités',
      'interoperabilidad': 'Interopérabilité',
      'confianza': 'Confiance',
      'articulos': 'Articles',
      'plataforma': 'Plateforme'
    },
    header: {
      'nav-plataforma': 'Plateforme',
      'nav-plataforma-caracteristicas': 'Comment ça marche',
      'nav-plataforma-caracteristicas-desc': 'Le cycle de vie du document',
      'nav-plataforma-interoperabilidad': 'Interopérabilité',
      'nav-plataforma-interoperabilidad-desc': 'Intégration avec systèmes',
      'nav-plataforma-confianza': 'Confiance et Sécurité',
      'nav-plataforma-confianza-desc': 'Conformité et protection',
      'nav-documentos': 'Documents',
      'nav-documentos-control': 'Document de Contrôle',
      'nav-documentos-control-desc': '🇪🇸 Obligatoire en Espagne',
      'nav-documentos-carta': 'Lettre de Voiture Numérique',
      'nav-documentos-carta-desc': '🇪🇸 Contractuel national',
      'nav-documentos-ecmr': 'eCMR International',
      'nav-documentos-ecmr-desc': '🇪🇺 Près de 40 pays adhérents',
      'nav-documentos-adr': 'Document de transport ADR',
      'nav-documentos-adr-desc': 'Marchandises dangereuses',
      'nav-empresa': 'Entreprise',
      'nav-empresa-quienes': 'Qui sommes-nous',
      'nav-empresa-quienes-desc': 'Notre histoire et équipe',
      'nav-empresa-articulos': 'Articles',
      'nav-empresa-articulos-desc': 'Guides et ressources',
      'nav-contacto': 'Contact',
      'nav-caracteristicas': 'Fonctionnalités',
      'nav-interoperabilidad': 'Interopérabilité',
      'nav-confianza': 'Confiance',
      'solicitar-demo': 'Demander une démo',
      'prueba-gratis': 'Demander un essai',
      'acceder': 'Se connecter'
    },
    footer: {
      'solucion': 'Solution',
      'recursos': 'Ressources',
      'empresa': 'Entreprise',
      'legal': 'Légal',
      'faq': 'FAQ',
      'articulos-guias': 'Articles et guides',
      'politica-privacidad': 'Politique de confidentialité',
      'politica-cookies': 'Politique des cookies',
      'cta-text': 'Préparez-vous à la documentation électronique. Demandez une démo dès aujourd\'hui.',
      'cta-button': 'Demander une démo',
      'copyright': 'Tous droits réservés.',
      'made-in': 'Fabriqué en Espagne',
      'nav-caracteristicas': 'Fonctionnalités',
      'nav-interoperabilidad': 'Interopérabilité',
      'nav-confianza': 'Confiance',
      'quienes-somos': 'Qui sommes-nous',
      'demo': 'Démo',
      'periodo-prueba': 'Période d\'essai',
      'contacto': 'Contact',
      'product-sheet': 'Fiche produit (PDF)'
    },
    demo: {
      'title': 'Demander une démo BlueCMR',
      'subtitle': 'Découvrez comment BlueCMR peut numériser vos documents de transport avec une validité juridique complète',
      'form-title': 'Demandez votre démo gratuite',
      'success-message': 'Merci ! Nous vous contacterons pour programmer votre démo personnalisée.',
      'name': 'Nom',
      'email': 'Email',
      'company': 'Entreprise',
      'phone': 'Téléphone',
      'company-type': 'Type d\'entreprise',
      'select': 'Sélectionner',
      'submit': 'Demander une démo gratuite'
    },
    landing: {
      'hero-title': 'Documents de transport numériques et professionnels',
      'hero-subtitle': 'Plateforme sécurisée avec validité juridique pour transporteurs et expéditeurs',
      'hero-cta': 'Demander une démo',
      'hero-cta-secondary': 'Voir les guides',
      'trusted-by': 'Numérisation du transport',
      'benefits-title': 'Avantages immédiats',
      'benefit-compliance': 'Conformité réglementaire',
      'benefit-compliance-desc': 'Documents valides pour inspection en transit avec garantie légale complète',
      'benefit-efficiency': 'Économies administratives',
      'benefit-efficiency-desc': 'Réduisez les heures d\'administration et accélérez l\'encaissement des factures',
      'benefit-security': 'Plus sécurisé',
      'benefit-security-desc': 'Signatures numériques avancées et documents toujours disponibles',
      'benefit-professional': 'Professionnalisme',
      'benefit-professional-desc': 'Gestion documentaire moderne et professionnelle avec les clients',
      'cta-final-title': 'Commencez la transition documentaire aujourd\'hui',
      'cta-final-subtitle': 'Rejoignez les entreprises déjà préparées pour l\'avenir numérique du transport',
      'cta-final-button': 'Demander une démo'
    },
    contact: {
      'title': 'Contact',
      'subtitle': 'Avez-vous des questions sur BlueCMR ? Nous sommes là pour vous aider.',
      'info-title': 'Informations de contact',
      'email': 'Email',
      'location': 'Localisation',
      'location-desc': 'Service dans toute l\'Union européenne',
      'schedule': 'Heures d\'ouverture',
      'schedule-hours': 'Lundi au vendredi : 8h30 - 15h00',
      'schedule-timezone': 'Fuseau horaire : CET (Madrid)',
      'form-title': 'Envoyez-nous un message',
      'form-name': 'Nom',
      'form-email': 'Email',
      'form-company': 'Entreprise',
      'form-subject': 'Sujet',
      'form-subject-placeholder': 'Sélectionnez un sujet',
      'form-subject-demo': 'Demander une démo',
      'form-subject-support': 'Support technique',
      'form-subject-integration': 'Intégration de systèmes',
      'form-subject-other': 'Autre',
      'form-message': 'Message',
      'form-message-placeholder': 'Dites-nous comment nous pouvons vous aider...',
      'form-privacy': 'J\'accepte la politique de confidentialité et le traitement de mes données personnelles.',
      'form-submit': 'Envoyer le message',
      'form-submitting': 'Envoi en cours...',
      'form-success': 'Merci ! Nous avons bien reçu votre message.',
      'form-error': 'Erreur lors de l\'envoi du formulaire. Veuillez réessayer.',
      'form-wait': 'Veuillez attendre quelques secondes avant d\'envoyer un autre message.',
      'form-review': 'Veuillez prendre un moment pour réviser le formulaire.',
      'form-attempts': 'Trop de tentatives. Veuillez recharger la page.'
    },
    plataforma: {
      'title': 'Fonctionnalités de la Plateforme',
      'subtitle': 'Tout ce dont vous avez besoin pour numériser vos documents de transport avec une garantie légale complète',
      'features-title': 'Fonctionnalités principales',
      'feature-documents': 'Documents supportés',
      'feature-documents-desc': 'DCA Numérique, Lettre de voiture, eCMR International',
      'feature-signature': 'Signature électronique avancée',
      'feature-signature-desc': 'Conforme eIDAS avec biométrie manuscrite',
      'feature-custody': 'Garde sécurisée',
      'feature-custody-desc': 'Stockage chiffré jusqu\'à 10 ans',
      'feature-api': 'API ouverte',
      'feature-api-desc': 'Intégration avec TMS, ERP et systèmes existants',
      'benefits-title': 'Avantages pour votre entreprise',
      'benefit-compliance': 'Conformité réglementaire totale',
      'benefit-efficiency': 'Réduction de 80% du temps administratif',
      'benefit-security': 'Sécurité et traçabilité complètes',
      'cta-title': 'Commencez dès aujourd\'hui',
      'cta-subtitle': 'Demandez une démonstration personnalisée',
      'cta-button': 'Demander une démo'
    },
    interoperabilidad: {
      'title': 'Interopérabilité',
      'subtitle': 'BlueCMR est conçu pour s\'intégrer parfaitement à votre écosystème technologique actuel',
      'efti-title': 'Standard eFTI Européen',
      'efti-desc': 'Prêt pour l\'échange électronique d\'informations de transport de marchandises',
      'api-title': 'API REST Complète',
      'api-desc': 'Intégration simple avec TMS, ERP et systèmes de gestion',
      'webhooks-title': 'Webhooks en temps réel',
      'webhooks-desc': 'Notifications automatiques d\'événements et changements d\'état',
      'formats-title': 'Formats multiples',
      'formats-desc': 'JSON, XML, PDF - Compatible avec tout système',
      'integration-title': 'Intégrations disponibles',
      'integration-tms': 'Systèmes TMS',
      'integration-erp': 'Systèmes ERP',
      'integration-pda': 'Appareils PDA',
      'integration-mobile': 'Applications mobiles'
    },
    confianza: {
      'title': 'Confiance et Sécurité',
      'subtitle': 'La sécurité et la validité légale de vos documents est notre priorité',
      'legal-title': 'Validité juridique complète',
      'legal-desc': 'Documents valides pour les inspections avec garantie légale complète',
      'eidas-title': 'Conformité eIDAS',
      'eidas-desc': 'Signature électronique avancée conforme au Règlement Européen',
      'timestamp-title': 'Horodatage',
      'timestamp-desc': 'Preuve temporelle irréfutable de la création du document',
      'custody-title': 'Garde sécurisée',
      'custody-desc': 'Stockage chiffré et accessible jusqu\'à 10 ans',
      'audit-title': 'Traçabilité complète',
      'audit-desc': 'Enregistrement détaillé de toutes les actions et modifications',
      'certificates-title': 'Certifications',
      'certificate-iso': 'ISO 27001 - Sécurité de l\'information',
      'certificate-gdpr': 'RGPD - Protection des données',
      'certificate-eidas': 'eIDAS - Signature électronique'
    },
    blog: {
      'title': 'Blog BlueCMR',
      'subtitle': 'Actualités, guides et ressources sur les documents de contrôle numériques',
      'categories': {
        'all': 'Tous',
        'administrative': 'Contrôle Administratif',
        'international': 'CMR International',
        'delivery': 'Bon de Livraison',
        'ecmr': 'eCMR',
        'regulation': 'Réglementation',
        'management': 'Gestion',
        'integrations': 'Intégrations',
        'technology': 'Technologie',
        'success': 'Cas de Succès',
        'tutorials': 'Tutoriels'
      },
      'featured': 'En vedette',
      'readArticle': 'Lire l\'Article',
      'readMore': 'Lire plus',
      'newsletter': {
        'title': 'Ne rien manquer ?',
        'subtitle': 'Abonnez-vous à notre newsletter et recevez les dernières nouvelles du secteur',
        'placeholder': 'votre@email.com',
        'button': 'S\'abonner'
      }
    },
    faq: {
      'title': 'Questions fréquentes',
      'subtitle': 'Nous résolvons les doutes les plus courants sur la numérisation documentaire dans le transport.',
      'questions': [
        {
          'question': 'Le Document de Contrôle Numérique est-il obligatoire ?',
          'answer': 'Pas encore. Le DCA numérique est légal en Espagne, mais son caractère obligatoire est prévu dans le cadre réglementaire de 2026.'
        },
        {
          'question': 'L\'eCMR est-il valide en Espagne ?',
          'answer': 'Oui. L\'Espagne est signataire du Protocole additionnel à la Convention CMR qui reconnaît la validité de l\'eCMR.'
        },
        {
          'question': 'Quel type de signature utilise BlueCMR ?',
          'answer': 'BlueCMR utilise une signature électronique avancée : biométrique manuscrite, conforme au Règlement eIDAS.'
        },
        {
          'question': 'Où sont stockés les documents ?',
          'answer': 'En garde chiffrée dans le cloud, avec disponibilité garantie pendant 10 ans et accès aux preuves en cas d\'inspection.'
        },
        {
          'question': 'Puis-je intégrer BlueCMR avec mes systèmes actuels ?',
          'answer': 'Oui. BlueCMR offre une API REST, des webhooks et des options d\'intégration pour s\'intégrer dans TMS, ERP ou PDA de conducteurs.'
        },
        {
          'question': 'Que se passe-t-il si un conducteur n\'a pas de connexion ?',
          'answer': 'Les documents peuvent être consultés hors ligne.'
        },
        {
          'question': 'Qu\'est-ce qui différencie BlueCMR des autres solutions ?',
          'answer': 'Sa simplicité d\'utilisation, son approche autogérée et ses coûts compétitifs, ainsi qu\'un cadre juridique et technique solide.'
        }
      ],
      'moreQuestions': {
        'title': 'Avez-vous plus de questions ?',
        'description': 'Si votre cas n\'apparaît pas dans les questions fréquentes, vous pouvez nous contacter directement. Notre équipe vous aidera à évaluer comment BlueCMR s\'adapte à vos processus.',
        'button': 'Parler avec nous'
      }
    },
    guias: {
      'title': 'Guides et Articles',
      'subtitle': 'Tout ce que vous devez savoir sur la documentation numérique de transport',
      'description': 'Guides pratiques, cadres juridiques et meilleures pratiques pour la numérisation du transport',
      'exploreByTopic': {
        'title': 'Explorer par thématique',
        'subtitle': 'Trouvez l\'information dont vous avez besoin organisée par domaines d\'intérêt'
      },
      'categories': {
        'documents': {
          'title': 'Documents',
          'articlesCount': 'articles spécialisés'
        },
        'compliance': {
          'title': 'Réglementation et conformité',
          'articlesCount': 'articles spécialisés'
        },
        'technology': {
          'title': 'Opération et technologie',
          'articlesCount': 'articles spécialisés'
        }
      },
      'featured': {
        'title': 'Articles en vedette',
        'subtitle': 'Les articles les plus utiles pour commencer votre numérisation'
      },
      'readArticle': 'Lire l\'article',
      'viewAll': 'Voir tous les articles',
      'readComplete': 'Lire le guide complet',
      'cta': {
        'title': 'Prêt à numériser ?',
        'subtitle': 'Mettez en pratique tout ce que vous avez appris avec une démo personnalisée de BlueCMR',
        'button': 'Demander une démo gratuite'
      }
    },
    blog: {
      'title': 'Blog BlueCMR',
      'subtitle': 'Actualités, guides et ressources sur les documents de contrôle numériques',
      'categories': {
        'all': 'Tous',
        'administrative': 'Contrôle Administratif',
        'international': 'CMR International',
        'delivery': 'Bon de Livraison',
        'ecmr': 'eCMR',
        'regulation': 'Réglementation',
        'management': 'Gestion',
        'integrations': 'Intégrations',
        'technology': 'Technologie',
        'success': 'Cas de Succès',
        'tutorials': 'Tutoriels'
      },
      'featured': 'En vedette',
      'readArticle': 'Lire l\'Article',
      'readMore': 'Lire plus',
      'newsletter': {
        'title': 'Ne rien manquer ?',
        'subtitle': 'Abonnez-vous à notre newsletter et recevez les dernières nouvelles du secteur',
        'placeholder': 'votre@email.com',
        'button': 'S\'abonner'
      }
    },
    faq: {
      'title': 'Questions fréquentes',
      'subtitle': 'Nous résolvons les doutes les plus courants sur la numérisation documentaire dans le transport.',
      'questions': [
        {
          'question': 'Le Document de Contrôle Numérique est-il obligatoire ?',
          'answer': 'Pas encore. Le DCA numérique est légal en Espagne, mais son caractère obligatoire est prévu dans le cadre réglementaire de 2026.'
        },
        {
          'question': 'L\'eCMR est-il valide en Espagne ?',
          'answer': 'Oui. L\'Espagne est signataire du Protocole additionnel à la Convention CMR qui reconnaît la validité de l\'eCMR.'
        },
        {
          'question': 'Quel type de signature utilise BlueCMR ?',
          'answer': 'BlueCMR utilise une signature électronique avancée : biométrique manuscrite, conforme au Règlement eIDAS.'
        },
        {
          'question': 'Où sont stockés les documents ?',
          'answer': 'En garde chiffrée dans le cloud, avec disponibilité garantie pendant 10 ans et accès aux preuves en cas d\'inspection.'
        },
        {
          'question': 'Puis-je intégrer BlueCMR avec mes systèmes actuels ?',
          'answer': 'Oui. BlueCMR offre une API REST, des webhooks et des options d\'intégration pour s\'intégrer dans TMS, ERP ou PDA de conducteurs.'
        },
        {
          'question': 'Que se passe-t-il si un conducteur n\'a pas de connexion ?',
          'answer': 'Les documents peuvent être consultés hors ligne.'
        },
        {
          'question': 'Qu\'est-ce qui différencie BlueCMR des autres solutions ?',
          'answer': 'Sa simplicité d\'utilisation, son approche autogérée et ses coûts compétitifs, ainsi qu\'un cadre juridique et technique solide.'
        }
      ],
      'moreQuestions': {
        'title': 'Avez-vous plus de questions ?',
        'description': 'Si votre cas n\'apparaît pas dans les questions fréquentes, vous pouvez nous contacter directement. Notre équipe vous aidera à évaluer comment BlueCMR s\'adapte à vos processus.',
        'button': 'Parler avec nous'
      }
    },
    guias: {
      'title': 'Guides et Articles',
      'subtitle': 'Tout ce que vous devez savoir sur la documentation numérique de transport',
      'description': 'Guides pratiques, cadres juridiques et meilleures pratiques pour la numérisation du transport',
      'exploreByTopic': {
        'title': 'Explorer par thématique',
        'subtitle': 'Trouvez l\'information dont vous avez besoin organisée par domaines d\'intérêt'
      },
      'categories': {
        'documents': {
          'title': 'Documents',
          'articlesCount': 'articles spécialisés'
        },
        'compliance': {
          'title': 'Réglementation et conformité',
          'articlesCount': 'articles spécialisés'
        },
        'technology': {
          'title': 'Opération et technologie',
          'articlesCount': 'articles spécialisés'
        }
      },
      'featured': {
        'title': 'Articles en vedette',
        'subtitle': 'Les articles les plus utiles pour commencer votre numérisation'
      },
      'readArticle': 'Lire l\'article',
      'viewAll': 'Voir tous les articles',
      'readComplete': 'Lire le guide complet',
      'cta': {
        'title': 'Prêt à numériser ?',
        'subtitle': 'Mettez en pratique tout ce que vous avez appris avec une démo personnalisée de BlueCMR',
        'button': 'Demander une démo gratuite'
      }
    },
    dcaDigital: {
      'title': 'Document de Contrôle Administratif de Transport Numérique Obligatoire',
      'subtitle': 'Guide complet : légalité actuelle, exigences techniques et avantages',
      'cta': 'Demander une démo du Document de Contrôle Numérique'
    },
    ecmrDigital: {
      'title': 'eCMR : la lettre de voiture électronique dans le transport international numérique',
      'subtitle': 'Guide complet sur le document électronique de transport international',
      'cta': 'Demander une démo eCMR'
    },
    efti: {
      'title': 'Qu\'est-ce que l\'eFTI et comment impactera-t-il la documentation de transport ?',
      'subtitle': 'Guide complet sur la réglementation eFTI : calendrier, avantages et impact sur les documents de transport numériques.',
      'cta': 'Demander une démo eFTI'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: I18N_CONFIG.defaultLanguage,
    fallbackLng: I18N_CONFIG.fallbackLanguage,
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    }
  });

// Registrar traducciones de firma electrónica
i18n.addResourceBundle('es', 'signature', signatureTranslations.es, true, true);
i18n.addResourceBundle('en', 'signature', signatureTranslations.en, true, true);

// Registrar traducciones de conservación de evidencias
i18n.addResourceBundle('es', 'evidence', evidenceTranslations.es, true, true);
i18n.addResourceBundle('en', 'evidence', evidenceTranslations.en, true, true);

// Registrar traducciones de eCMR
i18n.addResourceBundle('es', 'ecmr', ecmrTranslations.es, true, true);
i18n.addResourceBundle('en', 'ecmr', ecmrTranslations.en, true, true);

// Registrar traducciones de Carta de Porte
i18n.addResourceBundle('es', 'waybill', waybillTranslations.es, true, true);
i18n.addResourceBundle('en', 'waybill', waybillTranslations.en, true, true);

// Registrar traducciones de Terms and Conditions
i18n.addResourceBundle('es', 'terms', termsTranslations.es, true, true);
i18n.addResourceBundle('en', 'terms', termsTranslations.en, true, true);

// Registrar traducciones de Desarrolladores
i18n.addResourceBundle('es', 'developers', developersTranslations.es, true, true);
i18n.addResourceBundle('en', 'developers', developersTranslations.en, true, true);

export default i18n;
// Traducciones adicionales para Landing
i18n.addResourceBundle('es', 'landing', {
  'more-than-pdf': 'Mucho más que un PDF',
  'more-than-pdf-desc': 'Documentos de transporte digitales, preparados para las próximas obligaciones europeas.',
  'digitalization-title': 'La digitalización ya está aquí',
  'action-title': 'BlueCMR en acción',
  'platform-title': 'Todo lo que necesita en una plataforma',
  'why-title': 'Por qué elegir BlueCMR',
  'more-title': '¿Quiere saber más?',
  'hero-subtitle': 'DeCA de transporte (documento de control), eCMR y carta de porte digital con firma electrónica avanzada y trazabilidad completa.',
  'dca-2026': 'DeCA — Documento de Control 2026',
  'request-demo': 'Solicitar Demo',
  'try-bluecmr': 'Probar BlueCMR',
  'dca-digital-title': 'DeCA: el Documento de Control digital',
  'dca-mandatory-date': 'Desde el 5 de octubre de 2026, el documento de control debe gestionarse exclusivamente en formato digital en España: el DeCA (Documento electrónico de Control Administrativo).',
  'dca-compliance': 'BlueCMR te permite cumplir esta obligación legal de forma sencilla, sin cambiar tu operativa diaria y con acceso inmediato en inspección.',
  'see-dca': 'Ver el DeCA — Documento de Control digital',
  'why-bluecmr': '¿Por qué BlueCMR?',
  'compliance-title': 'Diseñado para cumplir la normativa',
  'compliance-desc': 'BlueCMR está construido específicamente para cumplir los requisitos técnicos y jurídicos exigidos en los documentos de transporte digitales.',
  'trust-compliance-link': 'Confianza y cumplimiento normativo',
  'daily-use-title': 'Pensado para el día a día del transporte',
  'daily-use-desc': 'Crea, comparte y firma documentos sin instalaciones, sin apps complejas y desde cualquier dispositivo.',
  'see-platform': 'Ver la plataforma',
  'integration-title': 'Preparado para integrarse',
  'integration-desc': 'Integra BlueCMR con tus sistemas de transporte, flota o gestión documental cuando lo necesites.',
  'simple-process': 'Proceso sencillo',
  'step-1': 'Crear',
  'step-1-desc': 'Genera el documento desde la plataforma o con tus datos habituales.',
  'step-2': 'Compartir',
  'step-2-desc': 'Envíalo por email, enlace, QR, SMS o WhatsApp.',
  'step-3': 'Firmar',
  'step-3-desc': 'Firma electrónica válida directamente desde el dispositivo.',
  'step-4': 'Verificar',
  'step-4-desc': 'Documento accesible y verificable en inspección.',
  'how-platform-works': 'Cómo funciona la plataforma',
  'transport-documents': 'Documentos de transporte',
  'documents-intro': 'BlueCMR permite gestionar digitalmente:',
  'dca-spain': 'DeCA — Documento de Control (España)',
  'dca-mandatory-2026': 'Obligatorio en formato digital desde el 5 de octubre de 2026',
  'carta-porte-national': 'Carta de Porte nacional',
  'carta-porte-desc': 'Documento contractual digital',
  'ecmr-international': 'eCMR',
  'ecmr-protocol': 'Conforme al Protocolo eCMR',

  'who-is-for': 'Para quién es BlueCMR',
  'shippers-operators': 'Cargadores',
  'shippers-desc': 'Genera documentos de transporte digitales para tus envíos, comparte con transportistas en un clic y mantén trazabilidad completa de cada expedición.',
  'carriers-fleets': 'Transportistas y flotas',
  'carriers-desc': 'Recibe y firma documentos en ruta desde el móvil, elimina el papel y cumple con la normativa del DeCA obligatorio.',
  'tech-teams': 'Proveedores de software',
  'tech-teams-desc': 'Ofrece eCMR integrado en tu software a través de nuestra API. Tus clientes digitalizan sus documentos de transporte sin salir de tu plataforma.',
  'resources-regulation': 'Recursos y normativa',
  'resources-intro': 'Consulta nuestras guías sobre digitalización del transporte:',
  'dca-guide': 'El DeCA (documento de control digital) y la obligatoriedad 2026',
  'dca-guide-desc': 'Guía completa sobre la normativa',
  'pdfa-guide': 'Requisitos técnicos del DeCA (Resolución 2026)',
  'pdfa-guide-desc': 'PDF nativo digital, firma avanzada y preparación eFTI',
  'differences-guide': 'Diferencias entre DeCA, Carta de Porte y eCMR',
  'differences-guide-desc': 'Comparativa de documentos',
  'efti-guide': 'Digitalización del DeCA y datos eFTI',
  'efti-guide-desc': 'Cómo preparar tu empresa para el intercambio electrónico de datos de transporte',
  'see-articles': 'Ver artículos',
  'final-cta': 'Prepárate hoy para la obligatoriedad del DeCA, el documento de control digital',
  'mandatory-info': 'Información sobre el DeCA, el documento de control obligatorio'
}, true, true);

i18n.addResourceBundle('en', 'landing', {
  'more-than-pdf': 'Much more than a PDF',
  'more-than-pdf-desc': 'Digital transport documents, ready for upcoming European obligations.',
  'digitalization-title': 'Digitization is already here',
  'action-title': 'BlueCMR in action',
  'platform-title': 'Everything you need in one platform',
  'why-title': 'Why choose BlueCMR',
  'more-title': 'Want to know more?',
  'hero-subtitle': 'eCMR, Waybill and Digital Control Document with advanced electronic signature and complete traceability.',
  'dca-2026': 'Digital Transport Documents',
  'request-demo': 'Request Demo',
  'try-bluecmr': 'Try BlueCMR',
  'dca-digital-title': 'Digital Control Document',
  'dca-mandatory-date': 'Since 5 October 2026, the Administrative Control Document must be managed exclusively in digital format in Spain.',
  'dca-compliance': 'BlueCMR allows you to comply with this legal obligation in a simple way, without changing your daily operations and with immediate access during inspection.',
  'see-dca': 'See Digital Control Document',
  'why-bluecmr': 'Why BlueCMR?',
  'compliance-title': 'Designed to comply with regulations',
  'compliance-desc': 'BlueCMR is built specifically to meet the technical and legal requirements demanded in digital transport documents.',
  'trust-compliance-link': 'Trust and regulatory compliance',
  'daily-use-title': 'Designed for daily transport operations',
  'daily-use-desc': 'Create, share and sign documents without installations, without complex apps and from any device.',
  'see-platform': 'See the platform',
  'integration-title': 'Ready to integrate',
  'integration-desc': 'Integrate BlueCMR with your transport, fleet or document management systems when you need it.',
  'simple-process': 'Simple process',
  'step-1': 'Create',
  'step-1-desc': 'Generate the document from the platform or with your usual data.',
  'step-2': 'Share',
  'step-2-desc': 'Send it by email, link, QR, SMS or WhatsApp.',
  'step-3': 'Sign',
  'step-3-desc': 'Valid electronic signature directly from the device.',
  'step-4': 'Verify',
  'step-4-desc': 'Document accessible and verifiable during inspection.',
  'how-platform-works': 'How the platform works',
  'transport-documents': 'Transport documents',
  'documents-intro': 'BlueCMR allows you to digitally manage:',
  'dca-spain': 'Administrative Control Document (Spain)',
  'dca-mandatory-2026': 'Mandatory in digital format since 5 October 2026',
  'carta-porte-national': 'National Waybill',
  'carta-porte-desc': 'Digital contractual document',
  'ecmr-international': 'eCMR',
  'ecmr-protocol': 'Compliant with the eCMR Protocol',

  'who-is-for': 'Who is BlueCMR for',
  'shippers-operators': 'Shippers',
  'shippers-desc': 'Generate digital transport documents for your shipments, share with carriers in one click and keep full traceability of every consignment.',
  'carriers-fleets': 'Carriers and fleets',
  'carriers-desc': 'Receive and sign documents on the road from your phone, eliminate paper and comply with mandatory control document regulations.',
  'tech-teams': 'Software providers',
  'tech-teams-desc': 'Offer integrated eCMR in your software through our API. Your clients digitize their transport documents without leaving your platform.',
  'resources-regulation': 'Resources and regulations',
  'resources-intro': 'Check our guides on transport digitization:',
  'dca-guide': 'Digital Control Document and 2026 mandatory requirement',
  'dca-guide-desc': 'Complete guide on regulations',
  'pdfa-guide': 'DeCA technical requirements (Resolution 2026)',
  'pdfa-guide-desc': 'Native digital PDF, advanced signature and eFTI preparation',
  'differences-guide': 'Differences between Control Document, Waybill and eCMR',
  'differences-guide-desc': 'Document comparison',
  'efti-guide': 'Control Document digitization and eFTI data',
  'efti-guide-desc': 'How to prepare your company for electronic transport data exchange',
  'see-articles': 'See articles',
  'final-cta': 'Get ready today for digital transport documents and eCMR',
  'mandatory-info': 'Information about the mandatory Administrative Control Document'
}, true, true);

i18n.addResourceBundle('fr', 'landing', {
  'more-than-pdf': 'Bien plus qu’un PDF',
  'more-than-pdf-desc': 'Documents de transport numériques, prêts pour les prochaines obligations européennes.',
  'digitalization-title': 'La numérisation est déjà là',
  'action-title': 'BlueCMR en action',
  'platform-title': 'Tout ce dont vous avez besoin en une plateforme',
  'why-title': 'Pourquoi choisir BlueCMR',
  'more-title': 'Vous voulez en savoir plus?',
  'hero-subtitle': 'eCMR, Lettre de Voiture et Document de Contrôle Numérique avec signature électronique avancée et traçabilité complète.',
  'dca-2026': 'Document de Contrôle 2026',
  'request-demo': 'Demander une Démo',
  'try-bluecmr': 'Essayer BlueCMR',
  'dca-digital-title': 'Document de Contrôle Numérique',
  'dca-mandatory-date': 'Depuis le 5 octobre 2026, le Document de Contrôle Administratif doit être géré exclusivement en format numérique en Espagne.',
  'dca-compliance': 'BlueCMR vous permet de respecter cette obligation légale de manière simple, sans changer vos opérations quotidiennes et avec un accès immédiat lors de l\'inspection.',
  'see-dca': 'Voir le Document de Contrôle numérique',
  'why-bluecmr': 'Pourquoi BlueCMR?',
  'compliance-title': 'Conçu pour respecter la réglementation',
  'compliance-desc': 'BlueCMR est construit spécifiquement pour répondre aux exigences techniques et juridiques requises dans les documents de transport numériques.',
  'trust-compliance-link': 'Confiance et conformité réglementaire',
  'daily-use-title': 'Conçu pour les opérations de transport quotidiennes',
  'daily-use-desc': 'Créez, partagez et signez des documents sans installations, sans applications complexes et depuis n\'importe quel appareil.',
  'see-platform': 'Voir la plateforme',
  'integration-title': 'Prêt à s\'intégrer',
  'integration-desc': 'Intégrez BlueCMR avec vos systèmes de transport, de flotte ou de gestion documentaire quand vous en avez besoin.',
  'simple-process': 'Processus simple',
  'step-1': 'Créer',
  'step-1-desc': 'Générez le document depuis la plateforme ou avec vos données habituelles.',
  'step-2': 'Partager',
  'step-2-desc': 'Envoyez-le par email, lien, QR, SMS ou WhatsApp.',
  'step-3': 'Signer',
  'step-3-desc': 'Signature électronique valide directement depuis l\'appareil.',
  'step-4': 'Vérifier',
  'step-4-desc': 'Document accessible et vérifiable lors de l\'inspection.',
  'how-platform-works': 'Comment fonctionne la plateforme',
  'transport-documents': 'Documents de transport',
  'documents-intro': 'BlueCMR permet de gérer numériquement:',
  'dca-spain': 'Document de Contrôle Administratif (Espagne)',
  'dca-mandatory-2026': 'Obligatoire en format numérique depuis le 5 octobre 2026',
  'carta-porte-national': 'Lettre de Voiture nationale',
  'carta-porte-desc': 'Document contractuel numérique',
  'ecmr-international': 'CMR / eCMR international',
  'ecmr-protocol': 'Conforme au Protocole eCMR',

  'who-is-for': 'Pour qui est BlueCMR',
  'shippers-operators': 'Chargeurs',
  'shippers-desc': 'Générez des documents de transport numériques pour vos expéditions, partagez avec les transporteurs en un clic et gardez une traçabilité complète de chaque envoi.',
  'carriers-fleets': 'Transporteurs et flottes',
  'carriers-desc': 'Recevez et signez les documents en route depuis votre téléphone, éliminez le papier et respectez la réglementation sur le document de contrôle obligatoire.',
  'tech-teams': 'Fournisseurs de logiciels',
  'tech-teams-desc': 'Proposez l\'eCMR intégré dans votre logiciel via notre API. Vos clients numérisent leurs documents de transport sans quitter votre plateforme.',
  'resources-regulation': 'Ressources et réglementation',
  'resources-intro': 'Consultez nos guides sur la numérisation du transport:',
  'dca-guide': 'Document de Contrôle numérique et obligation 2026',
  'dca-guide-desc': 'Guide complet sur la réglementation',
  'pdfa-guide': 'Exigences techniques du DeCA (Résolution 2026)',
  'pdfa-guide-desc': 'PDF natif numérique, signature avancée et préparation eFTI',
  'differences-guide': 'Différences entre Document de Contrôle, Lettre de Voiture et eCMR',
  'differences-guide-desc': 'Comparaison des documents',
  'efti-guide': 'Numérisation du Document de Contrôle et données eFTI',
  'efti-guide-desc': 'Comment préparer votre entreprise à l\'échange électronique de données de transport',
  'see-articles': 'Voir les articles',
  'final-cta': 'Préparez-vous aujourd\'hui pour l\'obligation du Document de Contrôle numérique',
  'mandatory-info': 'Informations sur le Document de Contrôle Administratif obligatoire'
}, true, true);
// Traducciones completas para Landing
i18n.addResourceBundle('es', 'landing', {
  'regulatory-badge': 'Actualidad normativa España',
  'legal-title': 'Ya es legal',
  'legal-desc': 'Los documentos de transporte digitales son legales en España desde 2009',
  'mandatory-title': 'Obligatorio desde el 5 de octubre de 2026',
  'mandatory-desc': 'El DeCA (documento de control digital) es obligatorio por la Ley de Movilidad Sostenible',
  'transition-title': 'Cumpla ya',
  'transition-desc': 'La obligación ya está en vigor: digitalice sus operaciones hoy',
  'mandatory-banner': 'DeCA (documento de control) obligatorio desde el 05 de octubre de 2026',
  'mandatory-banner-cta': 'Más información',
  'benefits-subtitle': 'Empiece a disfrutar de las ventajas de la digitalización desde el primer día',
  'action-subtitle': 'No es necesario instalar ninguna app móvil, todo funciona en entorno web',
  'step-create': 'Crear documento',
  'step-create-desc': 'Mediante integración con su sistema o manualmente, de forma simplificada y rápida',
  'step-share': 'Compartir',
  'step-share-desc': 'Compártalo por QR, email, SMS o WhatsApp de forma instantánea',
  'step-sign': 'Firmar',
  'step-sign-desc': 'Firma avanzada mediante enlace, sin instalar nada ni registrarse',
  'step-verify': 'Verificable',
  'step-verify-desc': 'El documento queda custodiado de forma segura y accesible para inspección en tránsito',
  'platform-subtitle': 'BlueCMR incluye todas las herramientas necesarias para digitalizar completamente su documentación de transporte.',
  'documents-title': 'Documentos soportados',
  'dca-title': 'DeCA — Documento electrónico de Control Administrativo (antes DCA)',
  'dca-desc': 'Obligatoriedad prevista a corto plazo en España',
  'carta-title': 'Carta de Porte Digital',
  'carta-desc': 'Documento contractual para transporte nacional',
  'ecmr-title': 'eCMR Internacional',
  'ecmr-desc': 'Conforme al Protocolo CMR para transporte internacional',
  'features-title': 'Características técnicas',
  'feature-signature': 'Firma electrónica avanzada conforme a eIDAS (biométrica manuscrita con OTP)',
  'feature-timestamp': 'Sellado de tiempo automático en documentos que lo requieran',
  'feature-custody': 'Custodia cifrada hasta 10 años',
  'feature-api': 'API abierta para integración con TMS, ERP o PDA',
  'feature-multidevice': 'Acceso multidispositivo (web, móvil, tablet) incluso offline (sin cobertura)',
  'why-subtitle': 'Una plataforma diseñada específicamente para el sector del transporte',
  'simple-title': 'Simple y rápido',
  'simple-desc': 'Pensado para facilitar la experiencia de los usuarios, sin instalar apps',
  'legal-title-2': 'Legal y seguro',
  'legal-desc-2': 'Siguiendo la legislación española, el Reglamento eIDAS y preparado para eFTI',
  'scalable-title': 'Escalable',
  'scalable-desc': 'Con funcionalidades adaptadas al tamaño y necesidades de su empresa',
  'reliable-title': 'Confiable',
  'reliable-desc': 'Evidencias accesibles, custodia segura y trazabilidad completa',
  'more-subtitle': 'Descubra más sobre BlueCMR.',
  'features-link': 'Características',
  'interoperability-link': 'Interoperabilidad',
  'trust-link': 'Confianza'
}, true, true);

i18n.addResourceBundle('en', 'landing', {
  'regulatory-badge': 'Regulatory news',
  'legal-title': 'Already legal',
  'legal-desc': 'Transport documents can already be issued digitally in Spain',
  'mandatory-title': 'Mandatory since 5 October 2026',
  'mandatory-desc': 'The Digital Administrative Control Document is mandatory in Spain since 5 October 2026',
  'transition-title': 'Comply now',
  'transition-desc': 'The obligation is already in force: digitise your operations today',
  'benefits-subtitle': 'Start enjoying the advantages of digitization from day one',
  'action-subtitle': 'No need to install any mobile app, everything works in web environment',
  'step-create': 'Create document',
  'step-create-desc': 'Through integration with your system or manually, in a simplified and fast way',
  'step-share': 'Share',
  'step-share-desc': 'Share it by QR, email, SMS or WhatsApp instantly',
  'step-sign': 'Sign',
  'step-sign-desc': 'Advanced signature via link, without installing anything or registering',
  'step-verify': 'Verifiable',
  'step-verify-desc': 'The document is securely stored and accessible for inspection in transit',
  'platform-subtitle': 'BlueCMR includes all the necessary tools to completely digitize your transport documentation.',
  'documents-title': 'Supported documents',
  'dca-title': 'Digital Administrative Control Document (DCA)',
  'dca-desc': 'Mandatory requirement expected in the short term in Spain',
  'carta-title': 'Digital Waybill',
  'carta-desc': 'Contractual document for national transport',
  'ecmr-title': 'International eCMR',
  'ecmr-desc': 'Compliant with the CMR Protocol for international transport',
  'features-title': 'Technical features',
  'feature-signature': 'Advanced electronic signature compliant with eIDAS (handwritten biometric with OTP)',
  'feature-timestamp': 'Automatic timestamping on documents that require it',
  'feature-custody': 'Encrypted custody for up to 10 years',
  'feature-api': 'Open API for integration with TMS, ERP or PDA',
  'feature-multidevice': 'Multi-device access (web, mobile, tablet) even offline (no coverage)',
  'why-subtitle': 'A platform designed specifically for the transport sector',
  'simple-title': 'Simple and fast',
  'simple-desc': 'Designed to facilitate user experience, without installing apps',
  'legal-title-2': 'Legal and secure',
  'legal-desc-2': 'Following Spanish legislation, eIDAS Regulation and prepared for eFTI',
  'scalable-title': 'Scalable',
  'scalable-desc': 'With functionalities adapted to the size and needs of your company',
  'reliable-title': 'Reliable',
  'reliable-desc': 'Accessible evidence, secure custody and complete traceability',
  'more-subtitle': 'Discover more about BlueCMR.',
  'features-link': 'Features',
  'interoperability-link': 'Interoperability',
  'trust-link': 'Trust'
}, true, true);
// Traducciones francesas para Landing
i18n.addResourceBundle('fr', 'landing', {
  'regulatory-badge': 'Actualités réglementaires',
  'legal-title': 'Déjà légal',
  'legal-desc': 'Les documents de transport peuvent déjà être émis numériquement en Espagne',
  'mandatory-title': 'Obligatoire depuis le 5 octobre 2026',
  'mandatory-desc': 'Le Document de Contrôle Administratif Numérique est obligatoire en Espagne depuis le 5 octobre 2026',
  'transition-title': 'Conformez-vous dès maintenant',
  'transition-desc': 'L’obligation est déjà en vigueur : numérisez vos opérations dès aujourd’hui',
  'benefits-subtitle': 'Commencez à profiter des avantages de la numérisation dès le premier jour',
  'action-subtitle': 'Pas besoin d\'installer d\'application mobile, tout fonctionne en environnement web',
  'step-create': 'Créer le document',
  'step-create-desc': 'Par intégration avec votre système ou manuellement, de manière simplifiée et rapide',
  'step-share': 'Partager',
  'step-share-desc': 'Partagez-le par QR, email, SMS ou WhatsApp instantanément',
  'step-sign': 'Signer',
  'step-sign-desc': 'Signature avancée via lien, sans rien installer ni s\'inscrire',
  'step-verify': 'Vérifiable',
  'step-verify-desc': 'Le document est stocké en sécurité et accessible pour inspection en transit',
  'platform-subtitle': 'BlueCMR inclut tous les outils nécessaires pour numériser complètement votre documentation de transport.',
  'documents-title': 'Documents supportés',
  'dca-title': 'Document de Contrôle Administratif Numérique (DCA)',
  'dca-desc': 'Obligation prévue à court terme en Espagne',
  'carta-title': 'Lettre de Voiture Numérique',
  'carta-desc': 'Document contractuel pour transport national',
  'ecmr-title': 'eCMR International',
  'ecmr-desc': 'Conforme au Protocole CMR pour transport international',
  'features-title': 'Caractéristiques techniques',
  'feature-signature': 'Signature électronique avancée conforme à eIDAS (biométrique manuscrite avec OTP)',
  'feature-timestamp': 'Horodatage automatique sur les documents qui l\'exigent',
  'feature-custody': 'Garde chiffrée jusqu\'à 10 ans',
  'feature-api': 'API ouverte pour intégration avec TMS, ERP ou PDA',
  'feature-multidevice': 'Accès multi-appareils (web, mobile, tablette) même hors ligne (sans couverture)',
  'why-subtitle': 'Une plateforme conçue spécifiquement pour le secteur du transport',
  'simple-title': 'Simple et rapide',
  'simple-desc': 'Conçu pour faciliter l\'expérience utilisateur, sans installer d\'applications',
  'legal-title-2': 'Légal et sécurisé',
  'legal-desc-2': 'Suivant la législation espagnole, le Règlement eIDAS et préparé pour eFTI',
  'scalable-title': 'Évolutif',
  'scalable-desc': 'Avec des fonctionnalités adaptées à la taille et aux besoins de votre entreprise',
  'reliable-title': 'Fiable',
  'reliable-desc': 'Preuves accessibles, garde sécurisée et traçabilité complète',
  'more-subtitle': 'Découvrez plus sur BlueCMR.',
  'features-link': 'Fonctionnalités',
  'interoperability-link': 'Interopérabilité',
  'trust-link': 'Confiance'
}, true, true);
// Traducciones completas para PlataformaPage
i18n.addResourceBundle('es', 'plataforma', {
  'step1-title': 'Creación del documento',
  'step1-desc': 'El flujo comienza con la creación del documento de transporte',
  'step1-feature1-title': 'Creación simplificada',
  'step1-feature1-item1': 'Formularios optimizados',
  'step1-feature1-item2': 'Campos claros',
  'step1-feature1-item3': 'Validaciones automáticas',
  'step1-feature2-title': 'Datos predefinidos',
  'step1-feature2-item1': 'Datos precargados',
  'step1-feature2-item2': 'Plantillas reutilizables',
  'step1-feature2-item3': 'Menos errores',
  'step1-feature3-title': 'Creación mediante API',
  'step1-feature3-item1': 'Desde TMS o ERP',
  'step1-feature3-item2': 'Integración automática',
  'step1-feature3-item3': 'Documento estructurado',
  'step1-result': 'Documento listo para compartirse o firmarse',
  'step2-title': 'Compartir el documento',
  'step2-desc': 'El documento puede compartirse según el rol y momento del transporte',
  'step2-feature1-title': 'Enviar para firma',
  'step2-feature1-item1': 'Conductores, cargadores, destinatarios',
  'step2-feature1-item2': 'Por email, enlace, QR, SMS o WhatsApp',
  'step2-feature2-title': 'Compartir en solo lectura',
  'step2-feature2-item1': 'Sin posibilidad de firma',
  'step2-feature2-item2': 'Para consulta o verificación',
  'step2-feature3-title': 'Transferir el documento',
  'step2-feature3-item1': 'Entre transportistas',
  'step2-feature3-item2': 'Mantiene historial y evidencias',
  'step2-feature3-item3': 'Útil en subcontrataciones',
  'step2-feature4-title': 'Envíos y firmas masivas',
  'step2-feature4-item1': 'Envío simultáneo de múltiples documentos',
  'step2-feature4-item2': 'Firma masiva en un solo paso',
  'step3-title': 'Firma del documento',
  'step3-desc': 'El documento se visualiza de forma clara en móviles y tablets, facilitando la firma por conductores y personal en ruta',
  'step3-feature1-title': 'Firma biométrica',
  'step3-feature1-item1': 'Manuscrita en dispositivo',
  'step3-feature1-item2': 'Captura de trazos',
  'step3-feature1-item3': 'Evidencia vinculada',
  'step3-feature2-title': 'Firma mediante sello digital',
  'step3-feature2-item1': 'Sin biometría',
  'step3-feature2-item2': 'Asociada a usuario/empresa',
  'step3-feature2-item3': 'Más rápida',
  'step3-feature3-title': 'Verificación OTP',
  'step3-feature3-item1': 'Código por SMS o email',
  'step3-feature3-item2': 'Capa adicional de seguridad',
  'step3-feature3-item3': 'Configurable por documento',
  'step3-result': 'Firma vinculada con evidencia verificable',
  'step4-title': 'Eventos durante el transporte',
  'step4-desc': 'El documento registra eventos relevantes durante el transporte',
  'step4-feature1-title': 'Incidencias',
  'step4-feature1-item1': 'Retrasos, rechazos',
  'step4-feature1-item2': 'Observaciones',
  'step4-feature2-title': 'Fotografías y adjuntos',
  'step4-feature2-item1': 'Fotos de carga/descarga',
  'step4-feature2-item2': 'Evidencias visuales',
  'step4-feature3-title': 'Cambios operativos',
  'step4-feature3-item1': 'Cambios de matrícula',
  'step4-feature3-item2': 'Sustitución de vehículo',
  'step4-feature3-item3': 'Cambios de conductor',
  'step4-result': 'Cada evento queda registrado y trazable',
  'step5-title': 'Cierre del documento',
  'step5-desc': 'Una vez finalizado el transporte, el documento se cierra',
  'step5-feature1-title': 'Documento cerrado',
  'step5-feature1-item1': 'No puede modificarse',
  'step5-feature1-item2': 'Preparado para conservación',
  'step5-feature2-title': 'Contenido del documento cerrado',
  'step5-feature2-item1': 'Firmas realizadas',
  'step5-feature2-item2': 'Eventos ocurridos',
  'step5-feature2-item3': 'Estado final',
  'step6-title': 'Conservación y acceso',
  'step6-desc': 'El documento se conserva con todas sus evidencias y permanece accesible incluso en situaciones de conectividad limitada',
  'step6-feature1-title': 'Se conserva',
  'step6-feature1-item1': 'Evidencias de firma',
  'step6-feature1-item2': 'Historial de eventos',
  'step6-feature1-item3': 'Adjuntos asociados',
  'step6-feature2-title': 'Acceso limitado',
  'step6-feature2-item1': 'Partes legitimadas',
  'step6-feature2-item2': 'Autoridades cuando corresponda',
  'step6-link-text': 'Conservación de evidencias',
  'documents-title': 'Documentos estándar y personalizados',
  'documents-subtitle': 'BlueCMR permite trabajar con los principales documentos de transporte reconocidos legalmente y crear documentos personalizados según su sector y características específicas, asegurando validez jurídica, trazabilidad y facilidad de uso:',
  'dca-title': 'DeCA — Documento de Control Obligatorio',
  'dca-desc': 'Reconocido en formato digital en España, válido para inspecciones en tránsito.',
  'carta-title': 'Carta de Porte digital',
  'carta-desc': 'Documentación contractual nacional que incluye los datos obligatorios y sustituye al DeCA.',
  'ecmr-title': 'eCMR',
  'ecmr-desc': 'Conforme al Protocolo CMR, marcos europeos de interoperabilidad, puede incluir menciones del DeCA y la Carta de Porte.',
  'custom-title': 'Documentos personalizados',
  'custom-desc': 'Adaptados a su sector y a los requerimientos de su empresa.',
  'creation-title': 'Creación simplificada',
  'creation-subtitle': 'Genere documentos en segundos con una interfaz intuitiva diseñada para el día a día del transporte.',
  'interface-title': 'Interfaz amigable',
  'interface-desc': 'Creación en muy poco tiempo con formularios optimizados para escritorio y móvil. Botones grandes, campos claros y navegación intuitiva.',
  'templates-title': 'Plantillas inteligentes',
  'templates-desc': 'Datos pregrabados por empresa, ruta y cliente. Rellene automáticamente campos recurrentes y personalice según sus necesidades.',
  'integration-title': 'Integración automática',
  'integration-desc': 'Conexión directa con TMS y ERP para generar documentos automáticamente desde sus sistemas de gestión existentes.',
  'signature-title': 'Firma sin app móvil',
  'share-title': 'Compartir fácilmente',
  'share-desc': 'Comparta documentos para firma mediante QR, email, SMS o WhatsApp.',
  'immediate-title': 'Firma inmediata',
  'immediate-desc': 'El destinatario firma en segundos, sin instalar nada ni registrarse.',
  'advanced-title': 'Firma avanzada',
  'advanced-desc': 'Biométrica manuscrita conforme a eIDAS con OTP para mayor seguridad.',
  'technology-title': 'Tecnología robusta y confiable',
  'technology-subtitle': 'Infraestructura diseñada para garantizar disponibilidad, seguridad y rendimiento.',
  'tech-features-title': 'Características técnicas',
  'timestamp': 'Sellado de tiempo',
  'timestamp-value': 'Automático',
  'custody': 'Custodia de documentos',
  'custody-value': 'Hasta 10 años',
  'availability': 'Disponibilidad',
  'availability-value': '99% SLA',
  'offline': 'Modo offline',
  'offline-value': 'Con app móvil',
  'audit-title': 'Auditoría y trazabilidad',
  'audit-complete': 'Registro completo de todas las acciones realizadas en cada documento',
  'audit-evidence': 'Evidencias digitales disponibles bajo requerimiento judicial',
  'audit-history': 'Historial inmutable con timestamps y certificados digitales',
  'integration-featured': 'Integración Destacada',
  'visibility-title': 'Visibilidad en tiempo real y análisis de datos',
  'visibility-subtitle': 'Integración con Cadenia para seguimiento completo y análisis inteligente de sus operaciones.',
  'cadenia-visibility': 'Cadenia Visibility',
  'cadenia-intelligence': 'Cadenia Intelligence',
  'cadenia-desc': 'Cadenia pertenece a la familia empresarial de eCMR, la integración conecta automáticamente sus documentos BlueCMR con datos de seguimiento y análisis avanzado.',
  'visit-cadenia': 'Visitar Cadenia.eu',
  'other-integration': '¿Necesita otra integración? No hay problema, puede conectar BlueCMR con múltiples fuentes de datos.',
  'see-interoperability': 'Ver Interoperabilidad',
  'learn-more': 'Saber más'
}, true, true);

i18n.addResourceBundle('en', 'plataforma', {
  'step1-title': 'Document creation',
  'step1-desc': 'The flow begins with the creation of the transport document',
  'step1-feature1-title': 'Simplified creation',
  'step1-feature1-item1': 'Optimized forms',
  'step1-feature1-item2': 'Clear fields',
  'step1-feature1-item3': 'Automatic validations',
  'step1-feature2-title': 'Predefined data',
  'step1-feature2-item1': 'Preloaded data',
  'step1-feature2-item2': 'Reusable templates',
  'step1-feature2-item3': 'Fewer errors',
  'step1-feature3-title': 'API creation',
  'step1-feature3-item1': 'From TMS or ERP',
  'step1-feature3-item2': 'Automatic integration',
  'step1-feature3-item3': 'Structured document',
  'step1-result': 'Document ready to be shared or signed',
  'step2-title': 'Share the document',
  'step2-desc': 'The document can be shared according to role and transport moment',
  'step2-feature1-title': 'Send for signature',
  'step2-feature1-item1': 'Drivers, shippers, consignees',
  'step2-feature1-item2': 'By email, link, QR, SMS or WhatsApp',
  'step2-feature2-title': 'Share read-only',
  'step2-feature2-item1': 'No signature possible',
  'step2-feature2-item2': 'For consultation or verification',
  'step2-feature3-title': 'Transfer the document',
  'step2-feature3-item1': 'Between carriers',
  'step2-feature3-item2': 'Maintains history and evidence',
  'step2-feature3-item3': 'Useful in subcontracting',
  'step2-feature4-title': 'Bulk sending and signing',
  'step2-feature4-item1': 'Simultaneous sending of multiple documents',
  'step2-feature4-item2': 'Bulk signing in a single step',
  'step3-title': 'Document signature',
  'step3-desc': 'The document is clearly displayed on mobile and tablets, facilitating signature by drivers and field personnel',
  'step3-feature1-title': 'Biometric signature',
  'step3-feature1-item1': 'Handwritten on device',
  'step3-feature1-item2': 'Stroke capture',
  'step3-feature1-item3': 'Linked evidence',
  'step3-feature2-title': 'Digital seal signature',
  'step3-feature2-item1': 'No biometrics',
  'step3-feature2-item2': 'Associated with user/company',
  'step3-feature2-item3': 'Faster',
  'step3-feature3-title': 'OTP verification',
  'step3-feature3-item1': 'Code via SMS or email',
  'step3-feature3-item2': 'Additional security layer',
  'step3-feature3-item3': 'Configurable per document',
  'step3-result': 'Signature linked with verifiable evidence',
  'step4-title': 'Events during transport',
  'step4-desc': 'The document records relevant events during transport',
  'step4-feature1-title': 'Incidents',
  'step4-feature1-item1': 'Delays, rejections',
  'step4-feature1-item2': 'Observations',
  'step4-feature2-title': 'Photos and attachments',
  'step4-feature2-item1': 'Loading/unloading photos',
  'step4-feature2-item2': 'Visual evidence',
  'step4-feature3-title': 'Operational changes',
  'step4-feature3-item1': 'License plate changes',
  'step4-feature3-item2': 'Vehicle replacement',
  'step4-feature3-item3': 'Driver changes',
  'step4-result': 'Each event is recorded and traceable',
  'step5-title': 'Document closure',
  'step5-desc': 'Once transport is completed, the document is closed',
  'step5-feature1-title': 'Closed document',
  'step5-feature1-item1': 'Cannot be modified',
  'step5-feature1-item2': 'Ready for preservation',
  'step5-feature2-title': 'Closed document contents',
  'step5-feature2-item1': 'Completed signatures',
  'step5-feature2-item2': 'Occurred events',
  'step5-feature2-item3': 'Final status',
  'step6-title': 'Preservation and access',
  'step6-desc': 'The document is preserved with all its evidence and remains accessible even in limited connectivity situations',
  'step6-feature1-title': 'Preserved',
  'step6-feature1-item1': 'Signature evidence',
  'step6-feature1-item2': 'Event history',
  'step6-feature1-item3': 'Associated attachments',
  'step6-feature2-title': 'Limited access',
  'step6-feature2-item1': 'Legitimate parties',
  'step6-feature2-item2': 'Authorities when applicable',
  'step6-link-text': 'Evidence preservation',
  'documents-title': 'Standard and custom documents',
  'documents-subtitle': 'BlueCMR allows you to work with the main legally recognized transport documents and create custom documents according to your sector and specific characteristics, ensuring legal validity, traceability and ease of use:',
  'dca-title': 'Mandatory Administrative Control Document',
  'dca-desc': 'Recognized in digital format in Spain, valid for inspections in transit.',
  'carta-title': 'Digital Waybill',
  'carta-desc': 'National contractual documentation that includes mandatory data and replaces the Control Document.',
  'ecmr-title': 'eCMR',
  'ecmr-desc': 'Compliant with the CMR Protocol, European interoperability frameworks, may include mentions of the Control Document and Waybill.',
  'custom-title': 'Custom documents',
  'custom-desc': 'Adapted to your sector and your company requirements.',
  'creation-title': 'Simplified creation',
  'creation-subtitle': 'Generate documents in seconds with an intuitive interface designed for daily transport operations.',
  'interface-title': 'User-friendly interface',
  'interface-desc': 'Creation in very little time with forms optimized for desktop and mobile. Large buttons, clear fields and intuitive navigation.',
  'templates-title': 'Smart templates',
  'templates-desc': 'Pre-recorded data by company, route and customer. Automatically fill recurring fields and customize according to your needs.',
  'integration-title': 'Automatic integration',
  'integration-desc': 'Direct connection with TMS and ERP to generate documents automatically from your existing management systems.',
  'signature-title': 'Signature without mobile app',
  'share-title': 'Easy sharing',
  'share-desc': 'Share documents for signature via QR, email, SMS or WhatsApp.',
  'immediate-title': 'Immediate signature',
  'immediate-desc': 'The recipient signs in seconds, without installing anything or registering.',
  'advanced-title': 'Advanced signature',
  'advanced-desc': 'Handwritten biometric compliant with eIDAS with OTP for greater security.',
  'technology-title': 'Robust and reliable technology',
  'technology-subtitle': 'Infrastructure designed to guarantee availability, security and performance.',
  'tech-features-title': 'Technical features',
  'timestamp': 'Timestamping',
  'timestamp-value': 'Automatic',
  'custody': 'Document custody',
  'custody-value': 'Up to 10 years',
  'availability': 'Availability',
  'availability-value': '99% SLA',
  'offline': 'Offline mode',
  'offline-value': 'With mobile app',
  'audit-title': 'Audit and traceability',
  'audit-complete': 'Complete record of all actions performed on each document',
  'audit-evidence': 'Digital evidence available under judicial requirement',
  'audit-history': 'Immutable history with timestamps and digital certificates',
  'integration-featured': 'Featured Integration',
  'visibility-title': 'Real-time visibility and data analysis',
  'visibility-subtitle': 'Integration with Cadenia for complete tracking and intelligent analysis of your operations.',
  'cadenia-visibility': 'Cadenia Visibility',
  'cadenia-intelligence': 'Cadenia Intelligence',
  'cadenia-desc': 'Cadenia belongs to the eCMR business family, the integration automatically connects your BlueCMR documents with tracking data and advanced analysis.',
  'visit-cadenia': 'Visit Cadenia.eu',
  'other-integration': 'Need another integration? No problem, you can connect BlueCMR with multiple data sources.',
  'see-interoperability': 'See Interoperability',
  'learn-more': 'Learn more'
}, true, true);

i18n.addResourceBundle('fr', 'plataforma', {
  'documents-title': 'Documents standard et personnalisés',
  'documents-subtitle': 'BlueCMR permet de travailler avec les principaux documents de transport légalement reconnus et de créer des documents personnalisés selon votre secteur et caractéristiques spécifiques, assurant validité juridique, traçabilité et facilité d\'utilisation :',
  'dca-title': 'Document de Contrôle Administratif Obligatoire',
  'dca-desc': 'Reconnu en format numérique en Espagne, valide pour les inspections en transit.',
  'carta-title': 'Lettre de Voiture numérique',
  'carta-desc': 'Documentation contractuelle nationale qui inclut les données obligatoires et remplace le Document de Contrôle.',
  'ecmr-title': 'eCMR',
  'ecmr-desc': 'Conforme au Protocole CMR, cadres européens d\'interopérabilité, peut inclure des mentions du Document de Contrôle et de la Lettre de Voiture.',
  'custom-title': 'Documents personnalisés',
  'custom-desc': 'Adaptés à votre secteur et aux exigences de votre entreprise.',
  'creation-title': 'Création simplifiée',
  'creation-subtitle': 'Générez des documents en secondes avec une interface intuitive conçue pour le quotidien du transport.',
  'interface-title': 'Interface conviviale',
  'interface-desc': 'Création en très peu de temps avec des formulaires optimisés pour ordinateur et mobile. Gros boutons, champs clairs et navigation intuitive.',
  'templates-title': 'Modèles intelligents',
  'templates-desc': 'Données pré-enregistrées par entreprise, itinéraire et client. Remplissez automatiquement les champs récurrents et personnalisez selon vos besoins.',
  'integration-title': 'Intégration automatique',
  'integration-desc': 'Connexion directe avec TMS et ERP pour générer des documents automatiquement depuis vos systèmes de gestion existants.',
  'signature-title': 'Signature sans app mobile',
  'share-title': 'Partage facile',
  'share-desc': 'Partagez des documents pour signature via QR, email, WhatsApp ou Telegram.',
  'immediate-title': 'Signature immédiate',
  'immediate-desc': 'Le destinataire signe en secondes, sans rien installer ni s\'inscrire.',
  'advanced-title': 'Signature avancée',
  'advanced-desc': 'Biométrique manuscrite conforme à eIDAS avec OTP pour plus de sécurité.',
  'technology-title': 'Technologie robuste et fiable',
  'technology-subtitle': 'Infrastructure conçue pour garantir disponibilité, sécurité et performance.',
  'tech-features-title': 'Caractéristiques techniques',
  'timestamp': 'Horodatage',
  'timestamp-value': 'Automatique',
  'custody': 'Garde des documents',
  'custody-value': 'Jusqu\'à 10 ans',
  'availability': 'Disponibilité',
  'availability-value': '99% SLA',
  'offline': 'Mode hors ligne',
  'offline-value': 'Avec app mobile',
  'audit-title': 'Audit et traçabilité',
  'audit-complete': 'Enregistrement complet de toutes les actions effectuées sur chaque document',
  'audit-evidence': 'Preuves numériques disponibles sous exigence judiciaire',
  'audit-history': 'Historique immuable avec horodatage et certificats numériques',
  'integration-featured': 'Intégration Vedette',
  'visibility-title': 'Visibilité en temps réel et analyse de données',
  'visibility-subtitle': 'Intégration avec Cadenia pour suivi complet et analyse intelligente de vos opérations.',
  'cadenia-visibility': 'Cadenia Visibility',
  'cadenia-intelligence': 'Cadenia Intelligence',
  'cadenia-desc': 'Cadenia appartient à la famille d\'entreprises eCMR, l\'intégration connecte automatiquement vos documents BlueCMR avec les données de suivi et l\'analyse avancée.',
  'visit-cadenia': 'Visiter Cadenia.eu',
  'other-integration': 'Besoin d\'une autre intégration ? Pas de problème, vous pouvez connecter BlueCMR avec plusieurs sources de données.',
  'see-interoperability': 'Voir Interopérabilité',
  'learn-more': 'En savoir plus'
}, true, true);
// Traducciones adicionales para PlataformaPage (expandibles, conclusión, Cadenia)
i18n.addResourceBundle('es', 'plataforma', {
  // Detail labels (expandibles)
  'step1-detail-label': 'Más sobre la creación de documentos',
  'step2-detail-label': 'Más sobre canales y opciones',
  'step3-detail-label': 'Más sobre los tipos de firma',
  'step3-link-text': 'Más sobre firma electrónica',
  'step4-detail-label': 'Más sobre los eventos registrables',
  'step5-detail-label': 'Más sobre el cierre del documento',
  'step6-detail-label': 'Más sobre conservación y especificaciones',
  'tech-specs-label': 'Especificaciones técnicas',
  // Conclusión
  'conclusion-title': 'El ciclo de vida completo del documento',
  'conclusion-desc': 'Desde la creación hasta la conservación, cada paso queda registrado con evidencias verificables.',
  'conclusion-tagline': 'Una plataforma diseñada para la operativa real del transporte.',
  // Personalización
  'customizable-title': 'Todo el flujo es personalizable',
  'customizable-desc': 'Cada paso del ciclo de vida se adapta a la operativa de su empresa. Elija qué documentos emitir, qué campos incluir, qué tipo de firma usar, quién puede firmar y cómo se comparten. BlueCMR se ajusta a su forma de trabajar, no al revés.',
  // CTA
  'cta-trial': 'Prueba gratuita',
  // Cadenia
  'unified-visibility': 'Visibilidad Unificada 360',
  'real-time-tracking': 'Seguimiento y Tiempo Real',
  'dynamic-eta': 'ETA dinámico y alertas',
  'supply-analytics': 'Supply Chain Analytics',
  'ai-agents': 'Agentes de IA',
  'supply-reports': 'Informes de Supply Chain',
}, true, true);

i18n.addResourceBundle('en', 'plataforma', {
  'step1-detail-label': 'More about document creation',
  'step2-detail-label': 'More about channels and options',
  'step3-detail-label': 'More about signature types',
  'step3-link-text': 'More about electronic signature',
  'step4-detail-label': 'More about recordable events',
  'step5-detail-label': 'More about document closure',
  'step6-detail-label': 'More about preservation and specifications',
  'tech-specs-label': 'Technical specifications',
  'conclusion-title': 'The complete document lifecycle',
  'conclusion-desc': 'From creation to preservation, every step is recorded with verifiable evidence.',
  'conclusion-tagline': 'A platform designed for real transport operations.',
  'customizable-title': 'The entire flow is customizable',
  'customizable-desc': 'Every step of the lifecycle adapts to your company\'s operations. Choose which documents to issue, which fields to include, which signature type to use, who can sign and how documents are shared. BlueCMR adjusts to your way of working, not the other way around.',
  'cta-trial': 'Free trial',
  'unified-visibility': 'Unified 360 Visibility',
  'real-time-tracking': 'Real-time Tracking',
  'dynamic-eta': 'Dynamic ETA and alerts',
  'supply-analytics': 'Supply Chain Analytics',
  'ai-agents': 'AI Agents',
  'supply-reports': 'Supply Chain Reports',
}, true, true);

i18n.addResourceBundle('fr', 'plataforma', {
  'step1-detail-label': 'En savoir plus sur la création de documents',
  'step2-detail-label': 'En savoir plus sur les canaux et options',
  'step3-detail-label': 'En savoir plus sur les types de signature',
  'step3-link-text': 'En savoir plus sur la signature électronique',
  'step4-detail-label': 'En savoir plus sur les événements enregistrables',
  'step5-detail-label': 'En savoir plus sur la clôture du document',
  'step6-detail-label': 'En savoir plus sur la conservation et spécifications',
  'tech-specs-label': 'Spécifications techniques',
  'conclusion-title': 'Le cycle de vie complet du document',
  'conclusion-desc': 'De la création à la conservation, chaque étape est enregistrée avec des preuves vérifiables.',
  'conclusion-tagline': 'Une plateforme conçue pour les opérations réelles du transport.',
  'customizable-title': 'Tout le flux est personnalisable',
  'customizable-desc': 'Chaque étape du cycle de vie s\'adapte aux opérations de votre entreprise. Choisissez quels documents émettre, quels champs inclure, quel type de signature utiliser, qui peut signer et comment les documents sont partagés. BlueCMR s\'ajuste à votre façon de travailler, pas l\'inverse.',
  'cta-trial': 'Essai gratuit',
  'unified-visibility': 'Visibilité Unifiée 360',
  'real-time-tracking': 'Suivi en Temps Réel',
  'dynamic-eta': 'ETA dynamique et alertes',
  'supply-analytics': 'Analytique Supply Chain',
  'ai-agents': 'Agents IA',
  'supply-reports': 'Rapports Supply Chain',
}, true, true);
// Traducciones completas para InteroperabilidadPage
i18n.addResourceBundle('es', 'interoperabilidad', {
  'tech-team-cta': 'Hablar con nuestro equipo técnico',
  'flexible-integration': 'Integración Flexible',
  'interoperability-options': 'Opciones de interoperabilidad',
  'connect-ecosystem': 'Conecte BlueCMR con su ecosistema tecnológico actual.',
  'api-title': 'API REST completa',
  'api-desc': 'Genere automáticamente el DeCA (documento de control), la Carta de Porte y el eCMR desde su TMS o ERP.',
  'api-endpoints': 'Endpoints para todos los tipos de documento',
  'api-auth': 'Autenticación segura',
  'api-docs': 'Documentación técnica completa',
  'import-title': 'Importación de archivos',
  'import-desc': 'Manual o automatizada, varios protocolos y formatos de ficheros aceptados.',
  'import-formats': 'Excel, CSV, XML, JSON',
  'import-validation': 'Validación automática de datos',
  'import-batch': 'Procesamiento por lotes',
  'widget-title': 'Widget embebido',
  'widget-desc': 'Los conductores firman y consultan documentos sin salir de su aplicación de gestión habitual.',
  'widget-native': 'Experiencia nativa en su app',
  'widget-sync': 'Sincronización automática',
  'widget-events': 'Eventos disponibles',
  'webhooks-title': 'Webhooks en tiempo real',
  'webhooks-desc': 'Reciba notificaciones instantáneas sobre estados de documentos y firmas.',
  'webhooks-urls': 'URLs configurables',
  'webhooks-events': 'Eventos configurables',
  'webhooks-retry': 'Reintentos automáticos',
  'efti-title': 'Estándar eFTI',
  'efti-desc': 'Todos los documentos siguen el conjunto de datos comunes eFTI para interoperabilidad europea.',
  'efti-format': 'Formato estándar europeo',
  'efti-exchange': 'Intercambio entre países',
  'efti-future': 'Futuro-compatible',
  'cadenia-title': 'Conector Cadenia',
  'cadenia-desc': 'Conecte automáticamente con Cadenia para seguimiento GPS y análisis de operaciones.',
  'cadenia-tracking': 'Seguimiento en tiempo real',
  'cadenia-analysis': 'Análisis de rutas y costes',
  'cadenia-ai': 'Analista de IA',
  'examples-title': 'Ejemplos prácticos de integración',
  'operator-title': 'Operador logístico',
  'operator-desc': 'Genera automáticamente la Carta de Porte desde su TMS al crear un envío.',
  'fleet-title': 'Flota con PDA propia',
  'fleet-desc': 'El conductor recibe el documento en su dispositivo habitual y lo firma mediante una url de BlueCMR embebida.',
  'traffic-title': 'Departamento de tráfico',
  'traffic-desc': 'Recibe en su ERP los documentos firmados y custodiados sin necesidad de entrar a otra plataforma.',
  'cta-final': 'Conecte BlueCMR con su infraestructura actual y digitalice documentos sin cambiar su forma de trabajar.',
  'tech-demo': 'Solicitar demo técnica',
  'developer-portal': 'Portal de desarrolladores'
}, true, true);

i18n.addResourceBundle('en', 'interoperabilidad', {
  'tech-team-cta': 'Talk to our technical team',
  'flexible-integration': 'Flexible Integration',
  'interoperability-options': 'Interoperability options',
  'connect-ecosystem': 'Connect BlueCMR with your current technology ecosystem.',
  'api-title': 'Complete REST API',
  'api-desc': 'Automatically generate Administrative Control Document, Waybill and eCMR from your TMS or ERP.',
  'api-endpoints': 'Endpoints for all document types',
  'api-auth': 'Secure authentication',
  'api-docs': 'Complete technical documentation',
  'import-title': 'File import',
  'import-desc': 'Manual or automated, various protocols and file formats accepted.',
  'import-formats': 'Excel, CSV, XML, JSON',
  'import-validation': 'Automatic data validation',
  'import-batch': 'Batch processing',
  'widget-title': 'Embedded widget',
  'widget-desc': 'Drivers sign and consult documents without leaving their usual management application.',
  'widget-native': 'Native experience in your app',
  'widget-sync': 'Automatic synchronization',
  'widget-events': 'Events available',
  'webhooks-title': 'Real-time webhooks',
  'webhooks-desc': 'Receive instant notifications about document and signature statuses.',
  'webhooks-urls': 'Configurable URLs',
  'webhooks-events': 'Configurable events',
  'webhooks-retry': 'Automatic retries',
  'efti-title': 'eFTI Standard',
  'efti-desc': 'All documents follow the eFTI common data set for European interoperability.',
  'efti-format': 'European standard format',
  'efti-exchange': 'Cross-country exchange',
  'efti-future': 'Future-compatible',
  'cadenia-title': 'Cadenia Connector',
  'cadenia-desc': 'Automatically connect with Cadenia for GPS tracking and operations analysis.',
  'cadenia-tracking': 'Real-time tracking',
  'cadenia-analysis': 'Route and cost analysis',
  'cadenia-ai': 'AI Analyst',
  'examples-title': 'Practical integration examples',
  'operator-title': 'Logistics operator',
  'operator-desc': 'Automatically generates the Waybill from their TMS when creating a shipment.',
  'fleet-title': 'Fleet with own PDA',
  'fleet-desc': 'The driver receives the document on their usual device and signs it through an embedded BlueCMR URL.',
  'traffic-title': 'Traffic department',
  'traffic-desc': 'Receives signed and custodied documents in their ERP without needing to enter another platform.',
  'cta-final': 'Connect BlueCMR with your current infrastructure and digitize documents without changing your way of working.',
  'tech-demo': 'Request technical demo',
  'developer-portal': 'Developer portal'
}, true, true);

i18n.addResourceBundle('fr', 'interoperabilidad', {
  'tech-team-cta': 'Parler à notre équipe technique',
  'flexible-integration': 'Intégration Flexible',
  'interoperability-options': 'Options d\'interopérabilité',
  'connect-ecosystem': 'Connectez BlueCMR avec votre écosystème technologique actuel.',
  'api-title': 'API REST complète',
  'api-desc': 'Générez automatiquement le Document de Contrôle Administratif, la Lettre de Voiture et l\'eCMR depuis votre TMS ou ERP.',
  'api-endpoints': 'Points de terminaison pour tous les types de documents',
  'api-auth': 'Authentification sécurisée',
  'api-docs': 'Documentation technique complète',
  'import-title': 'Importation de fichiers',
  'import-desc': 'Manuelle ou automatisée, divers protocoles et formats de fichiers acceptés.',
  'import-formats': 'Excel, CSV, XML, JSON',
  'import-validation': 'Validation automatique des données',
  'import-batch': 'Traitement par lots',
  'widget-title': 'Widget intégré',
  'widget-desc': 'Les conducteurs signent et consultent les documents sans quitter leur application de gestion habituelle.',
  'widget-native': 'Expérience native dans votre app',
  'widget-sync': 'Synchronisation automatique',
  'widget-events': 'Événements disponibles',
  'webhooks-title': 'Webhooks en temps réel',
  'webhooks-desc': 'Recevez des notifications instantanées sur les statuts des documents et signatures.',
  'webhooks-urls': 'URLs configurables',
  'webhooks-events': 'Événements configurables',
  'webhooks-retry': 'Tentatives automatiques',
  'efti-title': 'Standard eFTI',
  'efti-desc': 'Tous les documents suivent l\'ensemble de données communes eFTI pour l\'interopérabilité européenne.',
  'efti-format': 'Format standard européen',
  'efti-exchange': 'Échange entre pays',
  'efti-future': 'Compatible futur',
  'cadenia-title': 'Connecteur Cadenia',
  'cadenia-desc': 'Connectez automatiquement avec Cadenia pour le suivi GPS et l\'analyse des opérations.',
  'cadenia-tracking': 'Suivi en temps réel',
  'cadenia-analysis': 'Analyse des itinéraires et coûts',
  'cadenia-ai': 'Analyste IA',
  'examples-title': 'Exemples pratiques d\'intégration',
  'operator-title': 'Opérateur logistique',
  'operator-desc': 'Génère automatiquement la Lettre de Voiture depuis son TMS lors de la création d\'un envoi.',
  'fleet-title': 'Flotte avec PDA propre',
  'fleet-desc': 'Le conducteur reçoit le document sur son appareil habituel et le signe via une URL BlueCMR intégrée.',
  'traffic-title': 'Département de trafic',
  'traffic-desc': 'Reçoit dans son ERP les documents signés et gardés sans avoir besoin d\'entrer dans une autre plateforme.',
  'cta-final': 'Connectez BlueCMR avec votre infrastructure actuelle et numérisez les documents sans changer votre façon de travailler.',
  'tech-demo': 'Demander une démo technique',
  'developer-portal': 'Portail développeurs'
}, true, true);
// Traducciones completas para ConfianzaPage
i18n.addResourceBundle('es', 'confianza', {
  'request-demo': 'Solicitar demo',
  'trust-compliance': 'Confianza y cumplimiento sin fricción',
  'trust-intro': 'BlueCMR está diseñado para aportar valor probatorio a sus documentos electrónicos de transporte y alinearse con los requisitos del artículo 26 eIDAS.',
  'solution-based': 'La solución se basa en firma electrónica avanzada, combinando diferentes opciones según el nivel de seguridad requerido:',
  'signature-methods': 'Métodos de firma',
  'biometric-title': 'Firma biométrica manuscrita',
  'biometric-desc': 'opción principal, conforme a eIDAS.',
  'otp-title': 'OTP (One-Time Password)',
  'otp-desc': 'capa adicional de seguridad para documentos críticos.',
  'certificate-title': 'Certificado digital',
  'certificate-desc': 'firma con certificado local.',
  'validation-evidence': 'Validación y evidencias',
  'timestamp-title': 'Sellado de tiempo automático',
  'timestamp-desc': 'en los documentos que lo requieren.',
  'evidence-title': 'Evidencias disponibles',
  'evidence-desc': 'accesibles en caso de requerimiento judicial.',
  'pdf-title': 'Formatos de PDF avanzados',
  'pdf-desc': 'Documentos en formatos exigidos por las autoridades.',
  'integral-protection': 'Protección integral de datos y evidencias',
  'security-pillar': 'La seguridad es un pilar central en BlueCMR. Los documentos y registros se almacenan cifrados y con control granular de acceso, asegurando la protección frente a accesos no autorizados.',
  'data-protection': 'Protección de datos',
  'custody-title': 'Custodia cifrada (hasta 10 años)',
  'custody-desc': 'documentos y registros conservados.',
  'encryption-title': 'Cifrado',
  'encryption-desc': 'datos protegidos tanto en tránsito como en reposo.',
  'control-audit': 'Control y auditoría',
  'access-control-title': 'Control de accesos',
  'access-control-desc': 'permisos definidos por usuario y organización.',
  'audit-records-title': 'Registros inmutables de auditoría',
  'audit-records-desc': 'trazabilidad completa de todas las acciones.',
  'operational-continuity': 'Diseñado para la continuidad operativa',
  'cloud-deployment': 'BlueCMR está desplegado en la nube con alta disponibilidad y redundancia, garantizando acceso inmediato a los documentos en todo momento.',
  'aws-infrastructure': 'Infraestructura AWS en la UE',
  'aws-desc': 'Redundante, escalable y segura.',
  'multiplatform-access': 'Acceso multiplataforma',
  'multiplatform-desc': 'Disponible en web, móvil y tablet.',
  'secure-api': 'API segura',
  'secure-api-desc': 'Integraciones corporativas seguras.',
  'final-cta': 'Confíe en una solución preparada para exigencias regulatorias y auditorías del sector transporte.'
}, true, true);

i18n.addResourceBundle('en', 'confianza', {
  'request-demo': 'Request demo',
  'trust-compliance': 'Trust and compliance without friction',
  'trust-intro': 'BlueCMR is designed to provide probative value to your electronic transport documents and align with the requirements of Article 26 eIDAS.',
  'solution-based': 'The solution is based on advanced electronic signature, combining different options according to the required security level:',
  'signature-methods': 'Signature methods',
  'biometric-title': 'Handwritten biometric signature',
  'biometric-desc': 'main option, compliant with eIDAS.',
  'otp-title': 'OTP (One-Time Password)',
  'otp-desc': 'additional security layer for critical documents.',
  'certificate-title': 'Digital certificate',
  'certificate-desc': 'signature with local certificate.',
  'validation-evidence': 'Validation and evidence',
  'timestamp-title': 'Automatic timestamping',
  'timestamp-desc': 'on documents that require it.',
  'evidence-title': 'Available evidence',
  'evidence-desc': 'accessible in case of judicial requirement.',
  'pdf-title': 'Advanced PDF formats',
  'pdf-desc': 'Documents in formats required by authorities.',
  'integral-protection': 'Comprehensive data and evidence protection',
  'security-pillar': 'Security is a central pillar in BlueCMR. Documents and records are stored encrypted and with granular access control, ensuring protection against unauthorized access.',
  'data-protection': 'Data protection',
  'custody-title': 'Encrypted custody (up to 10 years)',
  'custody-desc': 'documents and records preserved.',
  'encryption-title': 'Encryption',
  'encryption-desc': 'data protected both in transit and at rest.',
  'control-audit': 'Control and audit',
  'access-control-title': 'Access control',
  'access-control-desc': 'permissions defined by user and organization.',
  'audit-records-title': 'Immutable audit records',
  'audit-records-desc': 'complete traceability of all actions.',
  'operational-continuity': 'Designed for operational continuity',
  'cloud-deployment': 'BlueCMR is deployed in the cloud with high availability and redundancy, guaranteeing immediate access to documents at all times.',
  'aws-infrastructure': 'AWS Infrastructure in the EU',
  'aws-desc': 'Redundant, scalable and secure.',
  'multiplatform-access': 'Multi-platform access',
  'multiplatform-desc': 'Available on web, mobile and tablet.',
  'secure-api': 'Secure API',
  'secure-api-desc': 'Secure corporate integrations.',
  'final-cta': 'Trust in a solution prepared for regulatory requirements and audits in the transport sector.'
}, true, true);

i18n.addResourceBundle('fr', 'confianza', {
  'request-demo': 'Demander une démo',
  'trust-compliance': 'Confiance et conformité sans friction',
  'trust-intro': 'BlueCMR est conçu pour apporter une valeur probante à vos documents de transport électroniques et s\'aligner sur les exigences de l\'article 26 eIDAS.',
  'solution-based': 'La solution est basée sur la signature électronique avancée, combinant différentes options selon le niveau de sécurité requis :',
  'signature-methods': 'Méthodes de signature',
  'biometric-title': 'Signature biométrique manuscrite',
  'biometric-desc': 'option principale, conforme à eIDAS.',
  'otp-title': 'OTP (One-Time Password)',
  'otp-desc': 'couche de sécurité supplémentaire pour les documents critiques.',
  'certificate-title': 'Certificat numérique',
  'certificate-desc': 'signature avec certificat local.',
  'validation-evidence': 'Validation et preuves',
  'timestamp-title': 'Horodatage automatique',
  'timestamp-desc': 'sur les documents qui l\'exigent.',
  'evidence-title': 'Preuves disponibles',
  'evidence-desc': 'accessibles en cas d\'exigence judiciaire.',
  'pdf-title': 'Formats PDF avancés',
  'pdf-desc': 'Documents dans les formats exigés par les autorités.',
  'integral-protection': 'Protection intégrale des données et preuves',
  'security-pillar': 'La sécurité est un pilier central dans BlueCMR. Les documents et enregistrements sont stockés chiffrés et avec un contrôle d\'accès granulaire, assurant la protection contre les accès non autorisés.',
  'data-protection': 'Protection des données',
  'custody-title': 'Garde chiffrée (jusqu\'à 10 ans)',
  'custody-desc': 'documents et enregistrements conservés.',
  'encryption-title': 'Chiffrement',
  'encryption-desc': 'données protégées en transit et au repos.',
  'control-audit': 'Contrôle et audit',
  'access-control-title': 'Contrôle d\'accès',
  'access-control-desc': 'permissions définies par utilisateur et organisation.',
  'audit-records-title': 'Enregistrements d\'audit immuables',
  'audit-records-desc': 'traçabilité complète de toutes les actions.',
  'operational-continuity': 'Conçu pour la continuité opérationnelle',
  'cloud-deployment': 'BlueCMR est déployé dans le cloud avec haute disponibilité et redondance, garantissant un accès immédiat aux documents à tout moment.',
  'aws-infrastructure': 'Infrastructure AWS dans l\'UE',
  'aws-desc': 'Redondante, évolutive et sécurisée.',
  'multiplatform-access': 'Accès multi-plateforme',
  'multiplatform-desc': 'Disponible sur web, mobile et tablette.',
  'secure-api': 'API sécurisée',
  'secure-api-desc': 'Intégrations d\'entreprise sécurisées.',
  'final-cta': 'Faites confiance à une solution préparée pour les exigences réglementaires et les audits du secteur des transports.'
}, true, true);
// Traducciones completas para DemoPage
i18n.addResourceBundle('es', 'demo', {
  'title': 'Solicitar demo BlueCMR',
  'subtitle': 'Descubra cómo BlueCMR puede digitalizar sus documentos de transporte con validez jurídica completa',
  'personalized-demo': 'Demo personalizada',
  'no-commitment': 'Sin compromiso',
  'quick-response': 'Respuesta rápida',
  'what-includes': '¿Qué incluye su demo personalizada?',
  'document-creation': 'Creación de documentos',
  'document-creation-desc': 'Vea cómo crear el DeCA (documento de control digital), la carta de porte o el eCMR con validez jurídica completa.',
  'signature-flow': 'Flujo de firmas',
  'signature-flow-desc': 'Experimente el proceso de firma electrónica avanzada sin necesidad de instalar aplicaciones.',
  'system-integration': 'Integración con sus sistemas',
  'system-integration-desc': 'Descubra cómo BlueCMR se integra con su TMS, ERP o sistema de gestión actual.',
  'personalized-analysis': 'Análisis personalizado',
  'personalized-analysis-desc': 'Evaluaremos su caso específico y le mostraremos el ROI estimado para su empresa.',
  'why-choose': '¿Por qué elegir BlueCMR?',
  'compliance': 'Cumplimiento total con normativa española y europea',
  'interoperability': 'Interoperabilidad con estándar eFTI',
  'adaptable-docs': 'Documentos adaptables a cualquier modalidad de transporte',
  'time-reduction': 'Reducción del 80% en tiempo administrativo',
  'request-demo': 'Solicite su demo gratuita',
  'name': 'Nombre',
  'name-placeholder': 'Su nombre',
  'email': 'Email',
  'email-placeholder': 'su@email.com',
  'company': 'Empresa',
  'company-placeholder': 'Nombre de su empresa',
  'phone': 'Teléfono',
  'phone-placeholder': '+34 600 000 000',
  'company-type': 'Tipo de empresa',
  'select': 'Seleccione',
  'shipper': 'Cargador/Expedidor',
  'carrier': 'Transportista',
  'logistics-operator': 'Operador logístico',
  'other': 'Otro',
  'documents-per-month': 'Documentos por mes',
  'select-volume': 'Seleccione volumen',
  'docs-1-100': '1-100 documentos',
  'docs-100-1000': '100-1000 documentos',
  'docs-1000-5000': '1000-5000 documentos',
  'docs-5000+': 'Más de 5000 documentos',
  'project-priority': 'Prioridad del proyecto',
  'select-urgency': 'Seleccione urgencia',
  'immediate': 'Necesidad inmediata',
  '1-3-months': 'En 1-3 meses',
  '3-6-months': 'En 3-6 meses',
  'exploring': 'Solo explorando opciones',
  'additional-comments': 'Comentarios adicionales',
  'comments-placeholder': 'Cuéntenos sobre sus necesidades específicas...',
  'privacy-accept': 'Acepto la política de privacidad y el tratamiento de mis datos personales para recibir información comercial de BlueCMR.',
  'privacy-policy': 'política de privacidad',
  'submit-demo': 'Solicitar demo gratuita',
  'submitting': 'Enviando solicitud...',
  'success-message': '¡Gracias! Hemos recibido su solicitud de demo. Nos pondremos en contacto con usted lo antes posible.',
  'error-message': 'Error al enviar el formulario. Por favor, inténtalo de nuevo.'
}, true, true);

i18n.addResourceBundle('en', 'demo', {
  'title': 'Request BlueCMR Demo',
  'subtitle': 'Discover how BlueCMR can digitize your transport documents with complete legal validity',
  'personalized-demo': 'Personalized demo',
  'no-commitment': 'No commitment',
  'quick-response': 'Quick response',
  'what-includes': 'What does your personalized demo include?',
  'document-creation': 'Document creation',
  'document-creation-desc': 'See how to create digital waybills or eCMR with complete legal validity.',
  'signature-flow': 'Signature flow',
  'signature-flow-desc': 'Experience the advanced electronic signature process without needing to install applications.',
  'system-integration': 'Integration with your systems',
  'system-integration-desc': 'Discover how BlueCMR integrates with your TMS, ERP or current management system.',
  'personalized-analysis': 'Personalized analysis',
  'personalized-analysis-desc': 'We will evaluate your specific case and show you the estimated ROI for your company.',
  'why-choose': 'Why choose BlueCMR?',
  'compliance': 'Full compliance with European regulations',
  'interoperability': 'Interoperability with eFTI standard',
  'adaptable-docs': 'Documents adaptable to any transport modality',
  'time-reduction': '80% reduction in administrative time',
  'request-demo': 'Request your free demo',
  'name': 'Name',
  'name-placeholder': 'Your name',
  'email': 'Email',
  'email-placeholder': 'your@email.com',
  'company': 'Company',
  'company-placeholder': 'Your company name',
  'phone': 'Phone',
  'phone-placeholder': '+44 20 0000 0000',
  'company-type': 'Company type',
  'select': 'Select',
  'shipper': 'Shipper/Consignor',
  'carrier': 'Carrier',
  'logistics-operator': 'Logistics operator',
  'other': 'Other',
  'documents-per-month': 'Documents per month',
  'select-volume': 'Select volume',
  'docs-1-100': '1-100 documents',
  'docs-100-500': '100-500 documents',
  'docs-500-2000': '500-2000 documents',
  'docs-2000+': 'More than 2000 documents',
  'project-priority': 'Project priority',
  'select-urgency': 'Select urgency',
  'immediate': 'Immediate need',
  '1-3-months': 'In 1-3 months',
  '3-6-months': 'In 3-6 months',
  'exploring': 'Just exploring options',
  'additional-comments': 'Additional comments',
  'comments-placeholder': 'Tell us about your specific needs...',
  'privacy-accept': 'I accept the privacy policy and the processing of my personal data to receive commercial information from BlueCMR.',
  'privacy-policy': 'privacy policy',
  'submit-demo': 'Request free demo',
  'submitting': 'Sending request...',
  'success-message': 'Thank you! We have received your demo request. We will contact you within the next 24 hours.',
  'error-message': 'Error sending the form. Please try again.'
}, true, true);

i18n.addResourceBundle('fr', 'demo', {
  'title': 'Demander une démo BlueCMR',
  'subtitle': 'Découvrez comment BlueCMR peut numériser vos documents de transport avec une validité juridique complète',
  'personalized-demo': 'Démo personnalisée',
  'no-commitment': 'Sans engagement',
  'quick-response': 'Réponse rapide',
  'what-includes': 'Que comprend votre démo personnalisée ?',
  'document-creation': 'Création de documents',
  'document-creation-desc': 'Voyez comment créer des lettres de voiture numériques ou eCMR avec une validité juridique complète.',
  'signature-flow': 'Flux de signatures',
  'signature-flow-desc': 'Expérimentez le processus de signature électronique avancée sans avoir besoin d\'installer d\'applications.',
  'system-integration': 'Intégration avec vos systèmes',
  'system-integration-desc': 'Découvrez comment BlueCMR s\'intègre avec votre TMS, ERP ou système de gestion actuel.',
  'personalized-analysis': 'Analyse personnalisée',
  'personalized-analysis-desc': 'Nous évaluerons votre cas spécifique et vous montrerons le ROI estimé pour votre entreprise.',
  'why-choose': 'Pourquoi choisir BlueCMR ?',
  'compliance': 'Conformité totale avec les réglementations européennes',
  'interoperability': 'Interopérabilité avec le standard eFTI',
  'adaptable-docs': 'Documents adaptables à toute modalité de transport',
  'time-reduction': 'Réduction de 80% du temps administratif',
  'request-demo': 'Demandez votre démo gratuite',
  'name': 'Nom',
  'name-placeholder': 'Votre nom',
  'email': 'Email',
  'email-placeholder': 'votre@email.com',
  'company': 'Entreprise',
  'company-placeholder': 'Nom de votre entreprise',
  'phone': 'Téléphone',
  'phone-placeholder': '+33 1 00 00 00 00',
  'company-type': 'Type d\'entreprise',
  'select': 'Sélectionner',
  'shipper': 'Expéditeur/Chargeur',
  'carrier': 'Transporteur',
  'logistics-operator': 'Opérateur logistique',
  'other': 'Autre',
  'documents-per-month': 'Documents par mois',
  'select-volume': 'Sélectionner le volume',
  'docs-1-100': '1-100 documents',
  'docs-100-500': '100-500 documents',
  'docs-500-2000': '500-2000 documents',
  'docs-2000+': 'Plus de 2000 documents',
  'project-priority': 'Priorité du projet',
  'select-urgency': 'Sélectionner l\'urgence',
  'immediate': 'Besoin immédiat',
  '1-3-months': 'Dans 1-3 mois',
  '3-6-months': 'Dans 3-6 mois',
  'exploring': 'Juste explorer les options',
  'additional-comments': 'Commentaires supplémentaires',
  'comments-placeholder': 'Parlez-nous de vos besoins spécifiques...',
  'privacy-accept': 'J\'accepte la politique de confidentialité et le traitement de mes données personnelles pour recevoir des informations commerciales de BlueCMR.',
  'privacy-policy': 'politique de confidentialité',
  'submit-demo': 'Demander une démo gratuite',
  'submitting': 'Envoi de la demande...',
  'success-message': 'Merci ! Nous avons reçu votre demande de démo. Nous vous contacterons dans les prochaines 24 heures.',
  'error-message': 'Erreur lors de l\'envoi du formulaire. Veuillez réessayer.'
}, true, true);
// Traducciones adicionales para Landing
i18n.addResourceBundle('es', 'landing', {
  'more-title': '¿Quiere saber más?',
  'more-subtitle': 'Descubra más sobre BlueCMR.',
  'features-link': 'Características',
  'interoperability-link': 'Interoperabilidad',
  'trust-link': 'Confianza'
}, true, true);

i18n.addResourceBundle('en', 'landing', {
  'more-title': 'Want to know more?',
  'more-subtitle': 'Discover more about BlueCMR.',
  'features-link': 'Features',
  'interoperability-link': 'Interoperability',
  'trust-link': 'Trust'
}, true, true);

i18n.addResourceBundle('fr', 'landing', {
  'more-title': 'Vous voulez en savoir plus ?',
  'more-subtitle': 'Découvrez plus sur BlueCMR.',
  'features-link': 'Fonctionnalités',
  'interoperability-link': 'Interopérabilité',
  'trust-link': 'Confiance'
}, true, true);
// Traducciones para QuienesSomosPage
i18n.addResourceBundle('es', 'about', {
  'title': 'Quiénes somos',
  'subtitle': 'Especialistas en documentación digital de transporte para el mercado europeo',
  'intro': 'BlueCMR es una plataforma especializada en documentación digital de transporte para el mercado europeo, desarrollada como filial de Cadenia desde Ponferrada (León).',
  'experience-title': 'Nuestra experiencia',
  'experience-subtitle': 'Nuestro equipo combina tres áreas de especialización clave que nos diferencian en el mercado',
  'tech-title': 'Experiencia técnica',
  'tech-desc': 'Desarrollo de software empresarial, sistemas de trazabilidad en tiempo real y arquitectura cloud serverless en AWS. Experiencia consolidada en el diseño e implementación de plataformas SaaS escalables.',
  'legal-title': 'Conocimiento legal',
  'legal-desc': 'Contamos con formación jurídica especializada en normativa de transporte española y europea: Reglamento eIDAS, Ley de Movilidad Sostenible, Reglamento eFTI, Protocolo eCMR. Este conocimiento legal nos permite anticipar requisitos normativos y garantizar el cumplimiento desde el diseño.',
  'sector-title': 'Experiencia sectorial',
  'sector-desc': 'Conocimiento directo del sector del transporte de mercancías por carretera, complementado con años trabajando con empresas de logística en España, Francia, Italia y Portugal. Entendemos los desafíos operativos reales y las particularidades de cada mercado europeo.',
  'founder-quote': 'El sector del transporte necesita herramientas que entiendan tanto la normativa como la realidad del día a día. Por eso creamos BlueCMR: cada funcionalidad combina cumplimiento legal, usabilidad práctica y tecnología moderna.',
  'founder-name': 'Jesús Santín',
  'founder-role': 'Director de BlueCMR',
  'approach-title': 'Nuestro enfoque',
  'compliance-title': 'Cumplimiento normativo',
  'compliance-desc': 'Cada funcionalidad está diseñada para cumplir con los requisitos técnicos y legales específicos del transporte europeo, tanto actuales como futuros.',
  'specialization-title': 'Especialización total',
  'specialization-desc': 'BlueCMR está construido desde cero para documentos de transporte. No es una herramienta genérica adaptada: cada detalle responde a necesidades reales del sector.',
  'quality-title': 'Calidad empresarial',
  'quality-desc': 'Infraestructura 100% serverless en AWS (regiones de Aragón y París), diseñada para ofrecer altos niveles de seguridad, escalabilidad y disponibilidad. Datos estructurados en formato eFTI.',
  'cadenia-title': 'Parte del grupo Cadenia',
  'cadenia-desc-1': 'BlueCMR y Cadenia forman parte del mismo grupo empresarial. Cadenia está especializada en soluciones de visibilidad en tiempo real e inteligencia aplicada a la cadena de suministro. BlueCMR nace con un foco exclusivo en documentación digital de transporte para el mercado europeo, compartiendo estándares de calidad y valores.',
  'cadenia-desc-2': 'Esta especialización nos permite ofrecer una solución que combina rigor técnico, cumplimiento legal y conocimiento profundo del sector.',
  'cta-title': '¿Hablamos?',
  'cta-subtitle': 'Si está evaluando soluciones para la digitalización de sus documentos de transporte, estaremos encantados de mostrarle cómo BlueCMR puede adaptarse a sus necesidades.',
  'cta-demo': 'Solicitar demo',
  'cta-contact': 'Contactar'
}, true, true);

i18n.addResourceBundle('en', 'about', {
  'title': 'About us',
  'subtitle': 'Specialists in digital transport documentation for the European market',
  'intro': 'BlueCMR is a platform specialized in digital transport documentation for the European market, developed as a subsidiary of Cadenia from Ponferrada (León, Spain).',
  'experience-title': 'Our experience',
  'experience-subtitle': 'Our team combines three key areas of specialization that differentiate us in the market',
  'tech-title': 'Technical expertise',
  'tech-desc': 'Enterprise software development, real-time traceability systems and serverless cloud architecture on AWS. Consolidated experience in the design and implementation of scalable SaaS platforms.',
  'legal-title': 'Legal knowledge',
  'legal-desc': 'We have specialized legal training in European transport regulations: eIDAS Regulation, eFTI Regulation, eCMR Protocol. This legal knowledge allows us to anticipate regulatory requirements and ensure compliance from design.',
  'sector-title': 'Sector experience',
  'sector-desc': 'Direct knowledge of the road freight transport sector, complemented by years working with logistics companies in Spain, France, Italy and Portugal. We understand the real operational challenges and the particularities of each European market.',
  'founder-quote': 'The transport sector needs tools that understand both regulations and day-to-day reality. That\'s why we created BlueCMR: each functionality combines legal compliance, practical usability and modern technology.',
  'founder-name': 'Jesús Santín',
  'founder-role': 'Director of BlueCMR',
  'approach-title': 'Our approach',
  'compliance-title': 'Regulatory compliance',
  'compliance-desc': 'Each functionality is designed to comply with the specific technical and legal requirements of European transport, both current and future.',
  'specialization-title': 'Total specialization',
  'specialization-desc': 'BlueCMR is built from scratch for transport documents. It is not an adapted generic tool: every detail responds to real sector needs.',
  'quality-title': 'Enterprise quality',
  'quality-desc': '100% serverless infrastructure on AWS (Aragon and Paris regions), designed to offer high levels of security, scalability and availability. Data structured in eFTI format.',
  'cadenia-title': 'Part of the Cadenia group',
  'cadenia-desc-1': 'BlueCMR and Cadenia are part of the same business group. Cadenia specializes in real-time visibility solutions and intelligence applied to the supply chain. BlueCMR was created with an exclusive focus on digital transport documentation for the European market, sharing quality standards and values.',
  'cadenia-desc-2': 'This specialization allows us to offer a solution that combines technical rigor, legal compliance and deep sector knowledge.',
  'cta-title': 'Let\'s talk?',
  'cta-subtitle': 'If you are evaluating solutions for digitizing your transport documents, we will be happy to show you how BlueCMR can adapt to your needs.',
  'cta-demo': 'Request demo',
  'cta-contact': 'Contact'
}, true, true);

i18n.addResourceBundle('fr', 'about', {
  'title': 'Qui sommes-nous',
  'subtitle': 'Spécialistes de la documentation numérique de transport pour le marché européen',
  'intro': 'BlueCMR est une plateforme spécialisée dans la documentation numérique de transport pour le marché européen, développée comme spinoff de Cadenia depuis Ponferrada (León, Espagne).',
  'experience-title': 'Notre expérience',
  'experience-subtitle': 'Notre équipe combine trois domaines clés de spécialisation qui nous différencient sur le marché',
  'tech-title': 'Expertise technique',
  'tech-desc': 'Développement de logiciels d\'entreprise, systèmes de traçabilité en temps réel et architecture cloud serverless sur AWS. Expérience consolidée dans la conception et la mise en œuvre de plateformes SaaS évolutives.',
  'legal-title': 'Connaissance juridique',
  'legal-desc': 'Nous disposons d\'une formation juridique spécialisée dans la réglementation des transports espagnole et européenne : Règlement eIDAS, Loi sur la Mobilité Durable, Règlement eFTI, Protocole eCMR. Cette connaissance juridique nous permet d\'anticiper les exigences réglementaires et de garantir la conformité dès la conception.',
  'sector-title': 'Expérience sectorielle',
  'sector-desc': 'Connaissance directe du secteur du transport routier de marchandises, complétée par des années de travail avec des entreprises de logistique en Espagne, France, Italie et Portugal. Nous comprenons les défis opérationnels réels et les particularités de chaque marché européen.',
  'founder-quote': 'Le secteur du transport a besoin d\'outils qui comprennent à la fois la réglementation européenne et la réalité quotidienne. C\'est pourquoi nous avons créé BlueCMR : chaque fonctionnalité combine conformité légale, utilisabilité pratique et technologie moderne, conçues pour tous les acteurs de la chaîne d\'approvisionnement.',
  'founder-name': 'Jesús Santín',
  'founder-role': 'Fondateur et Directeur',
  'approach-title': 'Notre approche',
  'compliance-title': 'Conformité réglementaire',
  'compliance-desc': 'Chaque fonctionnalité est conçue pour se conformer aux exigences techniques et légales spécifiques du transport européen, actuelles et futures.',
  'specialization-title': 'Spécialisation totale',
  'specialization-desc': 'BlueCMR est construit de zéro pour les documents de transport. Ce n\'est pas un outil générique adapté : chaque détail répond aux besoins réels du secteur.',
  'quality-title': 'Qualité d\'entreprise',
  'quality-desc': 'Infrastructure 100% serverless sur AWS (régions d\'Aragon et Paris), conçue pour offrir des niveaux élevés de sécurité, d\'évolutivité et de disponibilité. Données structurées au format eFTI dès le départ.',
  'cadenia-title': 'Partie du groupe Cadenia',
  'cadenia-desc-1': 'BlueCMR et Cadenia font partie du même groupe d\'entreprises. Cadenia est spécialisée dans les solutions de visibilité en temps réel et l\'intelligence appliquée à la chaîne d\'approvisionnement. BlueCMR a été créé avec un focus exclusif sur la documentation numérique de transport pour le marché européen, partageant des standards de qualité et des valeurs.',
  'cadenia-desc-2': 'Cette spécialisation nous permet d\'offrir une solution qui combine rigueur technique, conformité légale et connaissance approfondie du secteur.',
  'cta-title': 'Parlons-en ?',
  'cta-subtitle': 'Si vous évaluez des solutions pour la numérisation de vos documents de transport, nous serons ravis de vous montrer comment BlueCMR peut s\'adapter à vos besoins.',
  'cta-demo': 'Demander une démo',
  'cta-contact': 'Contact'
}, true, true);
// Traducciones para ECMRDigitalPage
i18n.addResourceBundle('es', 'ecmrDigital', {
  'title': 'eCMR: todo lo que necesitas saber sobre la carta de porte digital',
  'subtitle': 'Guía completa sobre el eCMR, su validez legal, beneficios y cómo implementarlo en tu empresa de transporte',
  'cta': 'Solicitar demo personalizada'
}, true, true);

// Traducciones para CumplimientoNormativoPage
i18n.addResourceBundle('es', 'compliance', {
  'hero-title': 'Cumplimiento normativo en BlueCMR',
  'hero-subtitle': 'La confianza en los documentos de transporte digitales depende de su validez jurídica, integridad técnica y trazabilidad',
  'intro-p1': 'BlueCMR ha sido diseñada para cumplir los requisitos técnicos y jurídicos exigidos por la normativa europea aplicable a la digitalización de documentos de transporte por carretera.',
  'intro-p2': 'Esta página describe qué marcos normativos aplican, qué exigen y cómo los implementa BlueCMR, delimitando claramente el alcance de la plataforma.',
  'framework-title': 'Marco normativo aplicable',
  'eidas-title': 'Reglamento eIDAS (UE 910/2014)',
  'eidas-desc': 'Establece el marco jurídico europeo para la identificación electrónica y los servicios de confianza, incluyendo la firma electrónica y la validez probatoria de los documentos electrónicos.',
  'ecmr-title': 'Protocolo adicional eCMR (2008)',
  'ecmr-desc': 'Permite el uso de la carta de porte electrónica en el transporte internacional de mercancías por carretera, siempre que se garantice la integridad del documento y la identificación de las partes.',
  'dca-title': 'Normativa nacional española',
  'dca-desc': 'La legislación española reconoce la validez de los documentos de transporte en formato digital y establece requisitos técnicos específicos para su gestión, conservación y presentación ante las autoridades competentes.',

  'efti-title': 'Marco eFTI (alineación)',
  'efti-desc': 'El Reglamento eFTI define los principios para el intercambio electrónico de información de transporte con las autoridades. BlueCMR se diseña de forma alineada con estos principios, sin perjuicio de los desarrollos reglementarios y certificaciones que correspondan en cada fase.',
  'requirements-title': 'Requisitos clave exigidos por la normativa',
  'requirements-intro': 'De forma transversal, la normativa aplicable exige que los documentos de transporte digitales garanticen:',
  'req-integrity': 'Integridad del contenido',
  'req-integrity-desc': 'El documento no puede ser alterado sin que quede constancia verificable.',
  'req-identification': 'Identificación del firmante',
  'req-identification-desc': 'Debe existir una vinculación clara entre la persona que firma y el acto de firma.',
  'req-consent': 'Evidencia del consentimiento',
  'req-consent-desc': 'La firma debe reflejar una voluntad expresa y atribuible.',
  'req-traceability': 'Trazabilidad del ciclo de vida',
  'req-traceability-desc': 'Las acciones relevantes sobre el documento deben poder reconstruirse en el tiempo.',
  'req-accessibility': 'Accesibilidad para las partes y autoridades',
  'req-accessibility-desc': 'El documento debe poder presentarse y verificarse cuando sea requerido.',
  'implementation-title': 'Cómo implementa BlueCMR estos requisitos',
  'implementation-intro': 'BlueCMR no se limita a almacenar documentos en formato PDF, sino que gestiona documentos de transporte estructurados, aplicando los siguientes principios:',
  'impl-1': 'Generación y conservación de documentos con integridad verificable',
  'impl-2': 'Uso de firma electrónica avanzada, conforme a eIDAS, para vincular identidad, documento y consentimiento',
  'impl-3': 'Registro de eventos y acciones relevantes a lo largo del ciclo de vida del documento',
  'impl-4': 'Disponibilidad controlada del documento y sus evidencias para las partes legitimadas y las autoridades',
  'impl-conclusion': 'Estos mecanismos permiten que los documentos generados y gestionados en BlueCMR sean jurídicamente defendibles y técnicamente verificables.',
  'scope-title': 'Alcance y responsabilidades',
  'scope-intro': 'BlueCMR actúa como plataforma tecnológica de soporte para la gestión de documentos de transporte digitales.',
  'scope-covers-title': 'Lo que cubre BlueCMR',
  'scope-covers-1': 'La infraestructura técnica para la creación, firma, trazabilidad y conservación de documentos digitales.',
  'scope-covers-2': 'La generación de evidencias electrónicas asociadas al documento.',
  'scope-parties-title': 'Lo que corresponde a las partes',
  'scope-parties-1': 'La veracidad de los datos introducidos.',
  'scope-parties-2': 'El cumplimiento de las obligaciones contractuales y operativas del transporte.',
  'scope-parties-3': 'El uso correcto del documento conforme a la normativa aplicable.',
  'scope-conclusion': 'BlueCMR no sustituye a las obligaciones legales de las partes, sino que facilita su cumplimiento en entorno digital.',
  'transparency-title': 'Transparencia y evolución normativa',
  'transparency-p1': 'La normativa aplicable a los documentos de transporte digitales está en evolución.',
  'transparency-p2': 'BlueCMR adopta un enfoque de transparencia y adaptación progresiva, alineando su diseño técnico con los marcos normativos vigentes y con aquellos que entrarán en aplicación de forma progresiva.',
  'cta-title': '¿Necesitas más información sobre cumplimiento normativo?',
  'cta-subtitle': 'Nuestro equipo puede resolver tus dudas sobre la normativa aplicable a tu caso específico',
  'cta-button': 'Contactar con el equipo'
}, true, true);

i18n.addResourceBundle('en', 'compliance', {
  'hero-title': 'Regulatory Compliance in BlueCMR',
  'hero-subtitle': 'Trust in digital transport documents depends on their legal validity, technical integrity and traceability',
  'intro-p1': 'BlueCMR has been designed to meet the technical and legal requirements demanded by European regulations applicable to the digitization of road transport documents.',
  'intro-p2': 'This page describes which regulatory frameworks apply, what they require and how BlueCMR implements them, clearly delimiting the scope of the platform.',
  'framework-title': 'Applicable regulatory framework',
  'eidas-title': 'eIDAS Regulation (EU 910/2014)',
  'eidas-desc': 'Establishes the European legal framework for electronic identification and trust services, including electronic signature and the probative value of electronic documents.',
  'ecmr-title': 'Additional eCMR Protocol (2008)',
  'ecmr-desc': 'Allows the use of electronic consignment notes in international road freight transport, provided that the integrity of the document and the identification of the parties are guaranteed.',
  'dca-title': 'National regulations',
  'dca-desc': 'National legislation recognizes the validity of transport documents in digital format and establishes specific technical requirements for their management, preservation and presentation to competent authorities.',

  'efti-title': 'eFTI Framework (alignment)',
  'efti-desc': 'The eFTI Regulation defines the principles for the electronic exchange of transport information with authorities. BlueCMR is designed in alignment with these principles, without prejudice to the regulatory developments and certifications that correspond in each phase.',
  'requirements-title': 'Key requirements demanded by regulations',
  'requirements-intro': 'Across the board, applicable regulations require that digital transport documents guarantee:',
  'req-integrity': 'Content integrity',
  'req-integrity-desc': 'The document cannot be altered without verifiable evidence.',
  'req-identification': 'Signer identification',
  'req-identification-desc': 'There must be a clear link between the person signing and the act of signing.',
  'req-consent': 'Evidence of consent',
  'req-consent-desc': 'The signature must reflect an express and attributable will.',
  'req-traceability': 'Lifecycle traceability',
  'req-traceability-desc': 'Relevant actions on the document must be reconstructable over time.',
  'req-accessibility': 'Accessibility for parties and authorities',
  'req-accessibility-desc': 'The document must be presentable and verifiable when required.',
  'implementation-title': 'How BlueCMR implements these requirements',
  'implementation-intro': 'BlueCMR is not limited to storing documents in PDF format, but manages structured transport documents, applying the following principles:',
  'impl-1': 'Generation and preservation of documents with verifiable integrity',
  'impl-2': 'Use of advanced electronic signature, compliant with eIDAS, to link identity, document and consent',
  'impl-3': 'Recording of events and relevant actions throughout the document lifecycle',
  'impl-4': 'Controlled availability of the document and its evidence for legitimate parties and authorities',
  'impl-conclusion': 'These mechanisms allow documents generated and managed in BlueCMR to be legally defensible and technically verifiable.',
  'scope-title': 'Scope and responsibilities',
  'scope-intro': 'BlueCMR acts as a technological support platform for the management of digital transport documents.',
  'scope-covers-title': 'What BlueCMR covers',
  'scope-covers-1': 'The technical infrastructure for the creation, signature, traceability and preservation of digital documents.',
  'scope-covers-2': 'The generation of electronic evidence associated with the document.',
  'scope-parties-title': 'What corresponds to the parties',
  'scope-parties-1': 'The veracity of the data entered.',
  'scope-parties-2': 'Compliance with contractual and operational transport obligations.',
  'scope-parties-3': 'Correct use of the document in accordance with applicable regulations.',
  'scope-conclusion': 'BlueCMR does not replace the legal obligations of the parties, but facilitates their compliance in a digital environment.',
  'transparency-title': 'Transparency and regulatory evolution',
  'transparency-p1': 'The regulations applicable to digital transport documents are evolving.',
  'transparency-p2': 'BlueCMR adopts an approach of transparency and progressive adaptation, aligning its technical design with current regulatory frameworks and those that will come into application progressively.',
  'cta-title': 'Need more information about regulatory compliance?',
  'cta-subtitle': 'Our team can answer your questions about the regulations applicable to your specific case',
  'cta-button': 'Contact the team'
}, true, true);

// Traducciones para SeguridadPage
i18n.addResourceBundle('es', 'security', {
  'hero-title': 'Seguridad en BlueCMR',
  'hero-subtitle': 'La seguridad es un pilar fundamental en la gestión de documentos de transporte digitales. BlueCMR ha sido diseñada con un enfoque de seguridad por diseño, protegiendo la información, los accesos y las evidencias documentales a lo largo de todo su ciclo de vida.',
  'intro': 'Esta página describe cómo se protege la plataforma, qué medidas técnicas se aplican y qué controles existen sobre el acceso y el tratamiento de la información.',
  'infrastructure-title': 'Infraestructura segura en la nube',
  'infrastructure-p1': 'BlueCMR opera sobre una infraestructura 100% desplegada en Amazon Web Services (AWS), utilizando servicios gestionados y ampliamente auditados del ecosistema AWS.',
  'infrastructure-principles': 'La arquitectura está basada en principios de:',
  'principle-isolation': 'Aislamiento de entornos',
  'principle-privilege': 'Mínimo privilegio',
  'principle-default': 'Seguridad por defecto',
  'infrastructure-p2': 'Los principales componentes de la plataforma se ejecutan sobre servicios serverless, reduciendo la superficie de ataque y eliminando la exposición innecesaria de servidores.',
  'crypto-title': 'Protección de la información y criptografía',
  'crypto-intro': 'La seguridad de la información en BlueCMR se apoya en mecanismos criptográficos robustos y gestionados.',
  'encryption-title': 'Cifrado de datos',
  'encryption-p1': 'Los datos se protegen mediante cifrado en tránsito y cifrado en reposo.',
  'encryption-p2': 'Las operaciones criptográficas se apoyan en AWS Key Management Service (KMS), que permite la gestión centralizada y controlada de claves.',
  'keys-title': 'Gestión de claves',
  'keys-p1': 'Las claves criptográficas no son accesibles directamente por los usuarios.',
  'keys-p2': 'El uso de KMS permite aplicar controles de acceso, rotación y auditoría sobre las operaciones criptográficas.',
  'crypto-conclusion': 'Este enfoque garantiza que la información esté protegida frente a accesos no autorizados, incluso a nivel de infraestructura.',
  'access-title': 'Control de accesos y autenticación',
  'access-intro': 'BlueCMR aplica controles estrictos de acceso a la plataforma, tanto a nivel de usuario como de sistema.',
  'auth-title': 'Autenticación de usuarios',
  'auth-1': 'Los usuarios se autentican mediante AWS Cognito, que gestiona identidades y credenciales de forma segura',
  'auth-2': 'Se admite doble factor de autenticación (2FA) mediante aplicaciones como Google Authenticator o Microsoft Authenticator',
  'auth-3': 'La plataforma incorpora progresivamente validación de número de teléfono móvil como factor adicional de verificación',
  'privilege-title': 'Principio de mínimo privilegio',
  'privilege-1': 'Cada usuario accede únicamente a la información y funcionalidades para las que está autorizado',
  'privilege-2': 'Los permisos se aplican de forma granular y contextual, reduciendo riesgos de acceso indebido',
  'serverless-title': 'Seguridad en la ejecución y arquitectura serverless',
  'serverless-intro': 'La lógica de negocio de BlueCMR se ejecuta mediante AWS Lambda, lo que aporta ventajas de seguridad relevantes:',
  'serverless-1-title': 'Sin servidores expuestos',
  'serverless-1-desc': 'No existen servidores permanentemente expuestos',
  'serverless-2-title': 'Entorno efímero',
  'serverless-2-desc': 'El entorno de ejecución es temporal y se destruye tras cada uso',
  'serverless-3-title': 'Permisos limitados',
  'serverless-3-desc': 'Cada función opera con permisos limitados y controlados',
  'serverless-conclusion': 'Este modelo reduce significativamente vectores de ataque habituales en arquitecturas tradicionales.',
  'audit-title': 'Registro de actividad y trazabilidad técnica',
  'audit-intro': 'La plataforma mantiene registros técnicos que permiten:',
  'audit-1-title': 'Detectar accesos',
  'audit-1-desc': 'Registro de accesos y acciones relevantes en la plataforma',
  'audit-2-title': 'Analizar eventos',
  'audit-2-desc': 'Análisis de eventos de seguridad para prevención',
  'audit-3-title': 'Investigar incidentes',
  'audit-3-desc': 'Investigación de incidentes de forma controlada',
  'audit-conclusion': 'Estos registros forman parte de los mecanismos de trazabilidad técnica, complementarios a la trazabilidad documental explicada en otras secciones de Confianza.',
  'protection-title': 'Protección frente a accesos no autorizados',
  'protection-intro': 'BlueCMR implementa medidas para prevenir y mitigar accesos indebidos, entre ellas:',
  'protection-1-title': 'Autenticación multifactor',
  'protection-1-desc': 'Verificación adicional mediante 2FA para mayor seguridad',
  'protection-2-title': 'Control de sesiones',
  'protection-2-desc': 'Gestión segura de sesiones con expiración automática',
  'protection-3-title': 'Validaciones progresivas',
  'protection-3-desc': 'Validación de identidad en múltiples niveles',
  'protection-4-title': 'Separación de datos',
  'protection-4-desc': 'Aislamiento entre datos, lógica y credenciales',
  'protection-conclusion': 'Estas medidas reducen el riesgo de suplantación y accesos no autorizados a documentos sensibles.',
  'shared-title': 'Seguridad y responsabilidades compartidas',
  'shared-intro': 'BlueCMR opera bajo un modelo de responsabilidad compartida:',
  'shared-bluecmr-title': 'Responsabilidad de BlueCMR',
  'shared-bluecmr-1': 'Proteger la infraestructura y la plataforma',
  'shared-bluecmr-2': 'Implementar controles de seguridad técnicos y organizativos',
  'shared-bluecmr-3': 'Garantizar la integridad y disponibilidad del servicio',
  'shared-user-title': 'Responsabilidad del usuario',
  'shared-user-1': 'Proteger sus credenciales',
  'shared-user-2': 'Utilizar mecanismos de autenticación reforzada',
  'shared-user-3': 'Gestionar adecuadamente los accesos dentro de su organización',
  'shared-conclusion': 'Este enfoque es coherente con los modelos de seguridad en la nube y con las mejores prácticas del sector.',
  'evolution-title': 'Evolución y mejora continua',
  'evolution-desc': 'La seguridad es un proceso continuo. BlueCMR revisa y mejora sus medidas de seguridad de forma progresiva, incorporando nuevos controles y mecanismos conforme evoluciona la plataforma, la normativa y el contexto tecnológico.',
  'cta-title': '¿Tienes dudas sobre la seguridad de la plataforma?',
  'cta-subtitle': 'Nuestro equipo técnico puede resolver tus preguntas sobre seguridad e infraestructura',
  'cta-button': 'Contactar con el equipo'
}, true, true);

i18n.addResourceBundle('en', 'security', {
  'hero-title': 'Security in BlueCMR',
  'hero-subtitle': 'Security is a fundamental pillar in the management of digital transport documents. BlueCMR has been designed with a security-by-design approach, protecting information, access and documentary evidence throughout its entire lifecycle.',
  'intro': 'This page describes how the platform is protected, what technical measures are applied and what controls exist over access and information processing.',
  'infrastructure-title': 'Secure cloud infrastructure',
  'infrastructure-p1': 'BlueCMR operates on a 100% deployed infrastructure on Amazon Web Services (AWS), using managed and widely audited services from the AWS ecosystem.',
  'infrastructure-principles': 'The architecture is based on principles of:',
  'principle-isolation': 'Environment isolation',
  'principle-privilege': 'Least privilege',
  'principle-default': 'Security by default',
  'infrastructure-p2': 'The main platform components run on serverless services, reducing the attack surface and eliminating unnecessary server exposure.',
  'crypto-title': 'Information protection and cryptography',
  'crypto-intro': 'Information security in BlueCMR relies on robust and managed cryptographic mechanisms.',
  'encryption-title': 'Data encryption',
  'encryption-p1': 'Data is protected through encryption in transit and encryption at rest.',
  'encryption-p2': 'Cryptographic operations rely on AWS Key Management Service (KMS), which allows centralized and controlled key management.',
  'keys-title': 'Key management',
  'keys-p1': 'Cryptographic keys are not directly accessible by users.',
  'keys-p2': 'The use of KMS allows applying access controls, rotation and auditing over cryptographic operations.',
  'crypto-conclusion': 'This approach ensures that information is protected against unauthorized access, even at the infrastructure level.',
  'access-title': 'Access control and authentication',
  'access-intro': 'BlueCMR applies strict access controls to the platform, both at user and system level.',
  'auth-title': 'User authentication',
  'auth-1': 'Users authenticate through AWS Cognito, which manages identities and credentials securely',
  'auth-2': 'Two-factor authentication (2FA) is supported through applications such as Google Authenticator or Microsoft Authenticator',
  'auth-3': 'The platform progressively incorporates mobile phone number validation as an additional verification factor',
  'privilege-title': 'Principle of least privilege',
  'privilege-1': 'Each user accesses only the information and functionalities for which they are authorized',
  'privilege-2': 'Permissions are applied in a granular and contextual manner, reducing risks of improper access',
  'serverless-title': 'Execution security and serverless architecture',
  'serverless-intro': 'BlueCMR business logic runs through AWS Lambda, which provides relevant security advantages:',
  'serverless-1-title': 'No exposed servers',
  'serverless-1-desc': 'There are no permanently exposed servers',
  'serverless-2-title': 'Ephemeral environment',
  'serverless-2-desc': 'The execution environment is temporary and destroyed after each use',
  'serverless-3-title': 'Limited permissions',
  'serverless-3-desc': 'Each function operates with limited and controlled permissions',
  'serverless-conclusion': 'This model significantly reduces common attack vectors in traditional architectures.',
  'audit-title': 'Activity logging and technical traceability',
  'audit-intro': 'The platform maintains technical records that allow:',
  'audit-1-title': 'Detect access',
  'audit-1-desc': 'Recording of access and relevant actions on the platform',
  'audit-2-title': 'Analyze events',
  'audit-2-desc': 'Analysis of security events for prevention',
  'audit-3-title': 'Investigate incidents',
  'audit-3-desc': 'Investigation of incidents in a controlled manner',
  'audit-conclusion': 'These records are part of the technical traceability mechanisms, complementary to the documentary traceability explained in other Trust sections.',
  'protection-title': 'Protection against unauthorized access',
  'protection-intro': 'BlueCMR implements measures to prevent and mitigate improper access, including:',
  'protection-1-title': 'Multi-factor authentication',
  'protection-1-desc': 'Additional verification through 2FA for greater security',
  'protection-2-title': 'Session control',
  'protection-2-desc': 'Secure session management with automatic expiration',
  'protection-3-title': 'Progressive validations',
  'protection-3-desc': 'Identity validation at multiple levels',
  'protection-4-title': 'Data separation',
  'protection-4-desc': 'Isolation between data, logic and credentials',
  'protection-conclusion': 'These measures reduce the risk of impersonation and unauthorized access to sensitive documents.',
  'shared-title': 'Security and shared responsibilities',
  'shared-intro': 'BlueCMR operates under a shared responsibility model:',
  'shared-bluecmr-title': 'BlueCMR responsibility',
  'shared-bluecmr-1': 'Protect infrastructure and platform',
  'shared-bluecmr-2': 'Implement technical and organizational security controls',
  'shared-bluecmr-3': 'Ensure service integrity and availability',
  'shared-user-title': 'User responsibility',
  'shared-user-1': 'Protect their credentials',
  'shared-user-2': 'Use reinforced authentication mechanisms',
  'shared-user-3': 'Properly manage access within their organization',
  'shared-conclusion': 'This approach is consistent with cloud security models and industry best practices.',
  'evolution-title': 'Evolution and continuous improvement',
  'evolution-desc': 'Security is an ongoing process. BlueCMR reviews and improves its security measures progressively, incorporating new controls and mechanisms as the platform, regulations and technological context evolve.',
  'cta-title': 'Do you have questions about platform security?',
  'cta-subtitle': 'Our technical team can answer your questions about security and infrastructure',
  'cta-button': 'Contact the team'
}, true, true);

// Traducciones para PruebaGratisPage
i18n.addResourceBundle('es', 'trial', {
  'seo-title': 'Probar BlueCMR | eCMR y documentos de transporte digitales',
  'seo-description': 'Solicita una prueba de BlueCMR. Conoce la plataforma de documentos de transporte digitales con firma electrónica y trazabilidad completa.',
  'title': 'Probar BlueCMR',
  'subtitle': 'Solicita un periodo de prueba y te ayudaremos a configurar tu cuenta para que conozcas la plataforma con tus propios documentos.',
  'badge-1': 'Prueba personalizada',
  'badge-2': 'Sin compromiso',
  'badge-3': 'Acompañamiento incluido',
  'includes-title': 'Qué incluye la prueba',
  'feature-documents': 'Documentos de transporte digitales',
  'feature-documents-desc': 'Crea eCMR, Cartas de Porte y DeCA (documentos de control) con validez legal completa.',
  'feature-mobile': 'App móvil incluida',
  'feature-mobile-desc': 'Firma y gestiona documentos en ruta desde tu teléfono, disponible en iOS y Android.',
  'feature-signature': 'Firma electrónica avanzada',
  'feature-signature-desc': 'Firma conforme a eIDAS con trazabilidad y evidencias de cada operación.',
  'feature-ready': 'Configuración asistida',
  'feature-ready-desc': 'Te ayudamos a configurar tu cuenta, plantillas y usuarios para que empieces a operar cuanto antes.',
  'form-title': 'Reserva tu reunión de activación',
  'form-subtitle': 'Elige una franja horaria para la reunión en la que activaremos tu periodo de prueba gratuita y te ayudaremos con la configuración inicial.',
  'name': 'Nombre',
  'email': 'Email corporativo',
  'company': 'Empresa',
  'phone': 'Teléfono',
  'privacy-accept': 'Acepto la política de privacidad y el tratamiento de mis datos para recibir información de BlueCMR.',
  'privacy-policy': 'política de privacidad',
  'submit-button': 'Solicitar prueba',
  'submitting': 'Enviando...',
  'success-message': 'Hemos recibido tu solicitud. Nos pondremos en contacto contigo en las próximas 24 horas para coordinar tu prueba.',
  'error-message': 'Ha ocurrido un error. Por favor, inténtalo de nuevo o escríbenos a contacto@bluecmr.com.',
  'pilot-title': '¿Grandes volúmenes de documentos?',
  'pilot-desc': 'Si tu empresa gestiona un alto volumen de expediciones, podemos coordinar un piloto con integración API para automatizar la creación de documentos desde tu ERP o TMS.',
  'pilot-link': 'Ver documentación API',
  'download-sheet': 'Descargar hoja de producto (PDF)'
}, true, true);

i18n.addResourceBundle('en', 'trial', {
  'seo-title': 'Try BlueCMR | eCMR and digital transport documents',
  'seo-description': 'Request a BlueCMR trial. Discover the digital transport document platform with electronic signature and full traceability.',
  'title': 'Try BlueCMR',
  'subtitle': 'Request a trial period and we will help you set up your account so you can explore the platform with your own documents.',
  'badge-1': 'Personalized trial',
  'badge-2': 'No commitment',
  'badge-3': 'Guided onboarding',
  'includes-title': 'What the trial includes',
  'feature-documents': 'Digital transport documents',
  'feature-documents-desc': 'Create eCMR, Waybills and Control Documents with full legal validity.',
  'feature-mobile': 'Mobile app included',
  'feature-mobile-desc': 'Sign and manage documents on the road from your phone, available on iOS and Android.',
  'feature-signature': 'Advanced electronic signature',
  'feature-signature-desc': 'eIDAS-compliant signature with traceability and evidence for every operation.',
  'feature-ready': 'Assisted setup',
  'feature-ready-desc': 'We help you configure your account, templates and users so you can start operating as soon as possible.',
  'form-title': 'Book your activation meeting',
  'form-subtitle': 'Choose a time slot for the meeting where we will activate your free trial and help you with the initial setup.',
  'name': 'Name',
  'email': 'Corporate email',
  'company': 'Company',
  'phone': 'Phone',
  'privacy-accept': 'I accept the privacy policy and the processing of my data to receive information from BlueCMR.',
  'privacy-policy': 'privacy policy',
  'submit-button': 'Request trial',
  'submitting': 'Sending...',
  'success-message': 'We have received your request. We will contact you within the next 24 hours to coordinate your trial.',
  'error-message': 'An error occurred. Please try again or write to contacto@bluecmr.com.',
  'pilot-title': 'High document volumes?',
  'pilot-desc': 'If your company manages a high volume of shipments, we can coordinate a pilot with API integration to automate document creation from your ERP or TMS.',
  'pilot-link': 'See API documentation',
  'download-sheet': 'Download product sheet (PDF)'
}, true, true);

i18n.addResourceBundle('fr', 'trial', {
  'seo-title': 'Essayer BlueCMR | eCMR et documents de transport numériques',
  'seo-description': 'Demandez un essai de BlueCMR. Découvrez la plateforme de documents de transport numériques avec signature électronique et traçabilité complète.',
  'title': 'Essayer BlueCMR',
  'subtitle': 'Demandez une période d\'essai et nous vous aiderons à configurer votre compte pour découvrir la plateforme avec vos propres documents.',
  'badge-1': 'Essai personnalisé',
  'badge-2': 'Sans engagement',
  'badge-3': 'Accompagnement inclus',
  'includes-title': 'Ce que comprend l\'essai',
  'feature-documents': 'Documents de transport numériques',
  'feature-documents-desc': 'Créez des eCMR, Lettres de Voiture et Documents de Contrôle avec une validité juridique complète.',
  'feature-mobile': 'Application mobile incluse',
  'feature-mobile-desc': 'Signez et gérez les documents en route depuis votre téléphone, disponible sur iOS et Android.',
  'feature-signature': 'Signature électronique avancée',
  'feature-signature-desc': 'Signature conforme eIDAS avec traçabilité et preuves pour chaque opération.',
  'feature-ready': 'Configuration assistée',
  'feature-ready-desc': 'Nous vous aidons à configurer votre compte, modèles et utilisateurs pour que vous puissiez commencer à opérer au plus vite.',
  'form-title': 'Réservez votre réunion d\'activation',
  'form-subtitle': 'Choisissez un créneau horaire pour la réunion où nous activerons votre essai gratuit et vous aiderons avec la configuration initiale.',
  'name': 'Nom',
  'email': 'Email professionnel',
  'company': 'Entreprise',
  'phone': 'Téléphone',
  'privacy-accept': 'J\'accepte la politique de privacidad et le traitement de mes données pour recevoir des informations de BlueCMR.',
  'privacy-policy': 'politique de confidentialité',
  'submit-button': 'Demander un essai',
  'submitting': 'Envoi en cours...',
  'success-message': 'Nous avons reçu votre demande. Nous vous contacterons dans les prochaines 24 heures pour organiser votre essai.',
  'error-message': 'Une erreur s\'est produite. Veuillez réessayer ou nous écrire à contacto@bluecmr.com.',
  'pilot-title': 'Grands volumes de documents ?',
  'pilot-desc': 'Si votre entreprise gère un volume élevé d\'expéditions, nous pouvons coordonner un pilote avec intégration API pour automatiser la création de documents depuis votre ERP ou TMS.',
  'pilot-link': 'Voir la documentation API',
  'download-sheet': 'Télécharger la fiche produit (PDF)'
}, true, true);

